export default {
	cadAeronave: {
		aviao: 'Plane',
		cadastroDeAeronave: 'Aircraft Register',
		ciclosT1: 'Cycles Flown NF',
		ciclosVoados: 'Cycles Flown',
		codinome: 'Codename',
		codinomeTipoIcao: 'Codename / ICAO Type',
		dadosAeroanve: 'Aircraft Data',
		dadosMotor: 'Powerplant Data',
		dataFabricacao: 'Date of Manufacture',
		dataUltima: 'Date of Last Maintenance',
		etiqueta: 'Label',
		fabricante: 'Manufacturer',
		helicoptero: 'Helicopter',
		horasVoadas: 'Hours Flown',
		imei: 'IMEI',
		matricula: 'Registration',
		modelo: 'Model',
		modeloMotor: 'Powerplant Model',
		motor: 'Powerplant',
		msgAtualizada: 'Aircraft updated successfully.',
		msgInserida: 'Inspection added successfully.',
		novaAeronave: 'New Aircraft',
		pousos: 'Landings',
		prefixo: 'Prefix',
		registro: 'Record',
		serialNumber: 'Serial Number',
		serialNumberMotor: 'Serial Number Motor',
		tailNumber: 'Tail Number',
		tipo: 'Type',
	},
	calendario: {
		domingo: 'sunday',
		hoje: 'Today',
		quartaFeira: 'wednesday',
		quintaFeira: 'thursday',
		segundaFeira: 'monday',
		sextaFeira: 'friday',
		sábado: 'saturday',
		terçaFeira: 'tuesday',
	},
	componentNatureza: {
		cAddItem: 'You can add just one item',
		cItem: 'No items added yet',
		cItemAdicionado: 'item already added',
		cItemJaAdicionado: 'This item already was added',
		cNatureza: 'Nature of Occurrence',
		cTipo: 'Type of Occurrence',
	},
	componentRAisp: {
		aisp: 'Aisp',
		risp: 'Risp',
	},
	conversao: {
		ano: 'year',
		anos: 'years',
		ciclos: 'cycle',
		dia: 'day',
		dias: 'days',
		hora: 'hour',
		horas: 'hours',
		mes: 'month',
		meses: 'months',
	},
	cores: {
		amarelo: 'Yellow',
		azul: 'Blue',
		cinza: 'Grey',
		laranja: 'Orange',
		preto: 'Black',
		roxo: 'Purple',
		verde: 'Green',
		vermelho: 'Red',
	},
	diasDaSemana: {
		domingo: 'Sun',
		quarta: 'Wed',
		quinta: 'Thu',
		sabado: 'Sat',
		segunda: 'Mon',
		sexta: 'Fri',
		terca: 'Tue',
	},
	diasSemana: {
		domingo: 'S',
		quarta: 'W',
		quinta: 'T',
		sabado: 'S',
		segunda: 'M',
		sexta: 'F',
		terca: 'T',
	},
	diasSemanaPos: {
		0: 'S',
		1: 'M',
		2: 'T',
		3: 'W',
		4: 'T',
		5: 'F',
		6: 'S',
	},
	gestao: {
		gestaoDe: 'Management',
	},
	global: {
		Altura: 'Height',
		Desativando: 'Deactivating',
		Dias: 'Days',
		Em: 'In',
		JornadaTrabalhoEFolgasProgramadas: 'Workday and Scheduled Breaks',
		Justificativa: 'Justification',
		NenhumaNFSEncontrada: 'No Invoice Found',
		PDFICPBrasil: 'PDF ICP Brasil',
		PagamentoDetalhes: 'Payment',
		PermissoesAcessoLayers: 'Access permissions to the layer',
		Por: 'Per',
		TipoDeEmbalagem: 'Kind of packing',
		aListaAbaixo: 'The list below',
		aOS: 'the WO',
		aOrdemInciaEm: 'The order will start in',
		aPartirDe: 'From',
		aQuantidadeFoiAlteradaComSucesso: 'The quantity has been successfully changed',
		aRecomendacaoFoiSalvaComSucesso: 'The recommendation was successfully saved',
		aSolicitacaoEstaAprovada: 'The request is <strong>APPROVED.</strong>',
		aSolicitacaoFoiDefinida: 'Request has been set for the operator',
		aSolicitacaoNaoAval: 'The request <strong> IS NOT </strong> supported by operations.',
		aSolicitacaoNaoTemAprovacao: 'The request  <strong>IS NOT</strong> approved.',
		aSolicitacaoNaoTemAvalManutencao: 'The request <strong>IS NOT </strong> supported by maintenance.',
		aSolicitacaoTemAvalManutencao: 'The request <strong>IS</strong> supported by maintenance.',
		aSolicitaoTemOaval: 'The request <strong>IS</strong> supported by operations.',
		aTarefaFoiAdicionadaComSucesso: 'The task was successfully added',
		aTarefaFoiSalvaComSucesso: 'Task has been saved successfully',
		abaixoDe: 'Below',
		abaixoEstaoOsTrechosAgrupados: 'Below are the leg grouped together.',
		abaixoMudancas: 'Below as changes made in this update',
		abastecedor: 'Supplier',
		abastecimento: 'Supply',
		abastecimentoAeronave: 'Aircraft Supply',
		abastecimentoDeAeronaveFoiDeletadoComSucesso: 'Aircraft supply was successfully deleted',
		abastecimentoDeAeronaveFoiSalvoComSucesso: 'Aircraft supply was saved successfully!',
		abastecimentoDeAeronaveViaApiContrato: 'Aircraft Supply via API/Contract',
		abastecimentoDeAeronaveViaUnidadeDeArmazenamento: 'Aircraft Supply, through the Storage Unit',
		abastecimentoOleo: 'Oil supply (L)',
		aberta: 'Open',
		aberto: 'Open',
		abertoPor: 'opened by: ',
		abertura: 'Opening',
		abrirChat: 'Open Chat',
		acao: 'Action',
		acaoAdotada: 'Adopted Action',
		acaoCorretiva: 'Corrective action',
		acaoPreventiva: 'Preventive action',
		acaoSalva: 'Action Saves',
		acaoTomada: 'Action taken',
		aceleracao: 'acceleration',
		acessar: 'Access',
		acessarApp: 'Access App',
		acesso: 'Access',
		acessoExcluido: 'Access successfully deleted',
		acimaDe: 'Above',
		acionamento: 'Activation',
		acoes: 'Actions',
		acoesTomadas: 'Actions taken',
		acumulado: 'Accumulated',
		acumuladoAno: 'Accumulated Year',
		acumuladoMes: 'Accumulated Month',
		acumuladoNoPeriodo: 'Accumulated in the Period',
		adendo: 'addendum',
		adicaoOleoLubrificante: 'Has lubricating oil been added?',
		adicionado: 'added',
		adicionadoSucesso: 'Successfully added',
		adicional: 'Additional',
		adicionar: 'ADD',
		adicionarAcao: 'Add Action',
		adicionarAditivo: 'Add additive',
		adicionarAeronave: 'Add Aircraft',
		adicionarAplicabilidade: 'Add applicability',
		adicionarBase: 'Add Base',
		adicionarCarga: 'add charge',
		adicionarCargaOpcao: 'This option allows you to display an \'ADD LOAD\' button on each work card in maintenance.',
		adicionarConfiguracao: 'Add Settings',
		adicionarContato: 'Add contact',
		adicionarDespacho: 'Add dispatch',
		adicionarDias: 'Add days',
		adicionarDiscrepancia: 'Add Discrepancy',
		adicionarDocumentacao: 'Add Documentation',
		adicionarEmpenhos: 'ADD Efforts',
		adicionarFrequencia: 'Add frequency',
		adicionarFuncao: 'Add Function',
		adicionarGrupo: 'ADD Group',
		adicionarInspecao: 'Add Inspection',
		adicionarInspecoes: 'Add Inspections',
		adicionarItem: 'ADD item',
		adicionarLayer: 'Add layer',
		adicionarMalhas: 'Add mashes',
		adicionarNovoParecer: 'Add new opinion',
		adicionarOcorrencia: 'Add Occurrence',
		adicionarOrgao: 'Add Agencies',
		adicionarPagamento: 'ADD PAYMENT',
		adicionarParecer: 'Add Opinion',
		adicionarPassageiro: 'Add Passenger',
		adicionarPeloMenosUmaInspecao: 'You have to add at least one inspection.',
		adicionarPeloMenosUmaPessoa: 'You have to add at least one person.',
		adicionarPeriodicidade: 'ADD FREQUENCY',
		adicionarPontos: 'Add Points',
		adicionarProgramacaoVoo: 'Add Flight Schedule',
		adicionarRessalva: 'Add caveat',
		adicionarSemana: 'Add Week',
		adicionarTarefa: 'Add Task',
		adicionarTarefas: 'Add Tasks',
		adicionarTipoDeSolicitacao: 'Add request type',
		adicionarTrecho: 'Add Leg',
		adicionarTripulacao: 'Add Crew',
		adicionarTripulante: 'ADD Crew Members',
		adicionarUnidade: 'Add Unit',
		adicionarUsuarios: 'Add User',
		adicionarValorAoContrato: 'Add value to the contract',
		adicionarVoo: 'Add Flight',
		adicionarVooEspecial: 'Add special Flight',
		adicionePeloMenosUmaTarefaParaCadaGrupoDeInspecoes: 'Add at least one task for each inspection group',
		adicioneUmRegistroDeLeitura: 'Add at least one record to the must-read table',
		aditivo: 'Additive',
		aditivoSalvoEContratoAtualizadoComSucesso: 'Additive saved and contract updated successfully',
		aditivos: 'Additions',
		administracaoEscolar: 'School Administration',
		administradorContrato: 'Supervisor / Contract Administrator',
		administradorSubstitutoDoContrato: 'Supervisor / Substitute Contract Administrator',
		administrativa: 'Administrative',
		aeronauta: 'Aeronaut',
		aeronavaArmazenamento: 'aircraft for fuel storage',
		aeronave: 'Aircraft',
		aeronaveAplicavel: 'Applicable Aircraft',
		aeronaveDestino: 'Aircraft Destination',
		aeronaveDisponivel: 'Aircraft available',
		aeronaveDuplicada: 'This aircraft is duplicated.',
		aeronaveIndisponivel: 'Aircraft unavailable',
		aeronaveNaoRetornouAoServico: 'The aircraft did not return to service because there is an open order',
		aeronaveNãoEncontrada: 'Aircraft not found',
		aeronaveParada: 'Aircraft stopped',
		aeronaveTurnoServico: 'work shift aircraft',
		aeronavesAsasFixas: 'Aircraft Fixed Wings',
		aeronavesAsasRotativas: 'Aircraft Rotating Handles',
		aeronavesEDisponibilidade: 'Aircraft Availability',
		aeronavesEmpregadas: 'Aircraft Employee',
		aeronavesOperadasPelo: 'Aircraft Operated by',
		aeroporto: 'Airport',
		afastamentoVor: 'VOR Remoteness(NM)',
		agrupado: 'Grouped',
		agruparTrecho: 'Group Leg',
		agruparTrechos: 'Group Legs',
		aguardandoLeitura: 'Awaiting reading',
		aindaNaoAvaliado: 'Not evaluated',
		aindaNaoLido: 'Not read yet',
		ajustes: 'SETTINGS',
		alergia: 'Allergy',
		alerta: 'Alert',
		alertaCalculoAutomatico1: 'Automatic flight time calculation is not available,',
		alertaCalculoAutomatico2: 'average speed, fuel consumption and tank have not been added for this aircraft.',
		alertas: 'Alerts',
		alinhaTabela: 'To Align Table',
		almoco: 'Lunch',
		alocacao: 'Allocation',
		alta: 'High',
		alteracao: 'Alteration',
		alteracoesEdicao: 'Changes saved and signature done successfully!',
		alteradoPor: 'Modified by',
		alterandoAQuantidade: 'Changing the quantity',
		alterandoSenha: 'Changing your password',
		alterar: 'Change',
		alterarAQuantidade: 'Change the quantity',
		alterarAssinatura: 'Change Signature',
		alterarAssinaturaNoProximoLogin: 'Change Signature on next login?',
		alterarDespacho: 'Change Dispatch',
		alterarProgramacaoVoo: 'Change Flight Schedule',
		alterarQuantidade: 'Change Quantity',
		alterarSenha: 'Change the password',
		alterarSenhaProximoLogin: 'Change password at next login?',
		alterarStatus: 'Change status',
		alternativos: 'Alternatives',
		altitude: 'Altitude',
		altitudeRecuperadaAtraves: 'Altitude recovered through Google Maps',
		altitudeTerreno: 'Ground Altitude',
		altitudeVelocidade: 'Altitude and Speed',
		altura: 'Height',
		alturaVoo: 'Flight Height',
		aluno: 'Student',
		alunos: 'Students',
		ambiente: 'Environment',
		anac: 'FAA',
		and: 'and',
		anexeUmaImagem: 'Attach an image',
		anexo: 'Attachment',
		anexoSolicitacao: 'Request\'s Attachment',
		ano: 'Year',
		anoFabricacao: 'Year of manufacture',
		anoModelo: 'Model Year',
		anos: 'Years',
		anual: 'Annual',
		apareceraDespachoAeronaves: 'Will it appear in the Aircraft Dispatch until the option \'Close this dispatch?\' be marked as YES.',
		aplicabilidade: 'applicability',
		aplicar: 'Apply',
		aplicativoTelaLogin: 'Login Screen Application',
		aplicavel: 'applicable',
		apoiados: 'Supported',
		aposSelecionarInspecao: 'After selecting all the inspections you want, click \'Add Inspections\'.',
		apresentacao: 'Presentation',
		aprovacao: 'Approval',
		aprovado: 'Approved',
		aprovarEssaSolicitacao: 'Approve this request (Generate Order of Mission)?',
		areaCriacao: 'Creation Area',
		areaMapeamento: 'Mapping Area',
		areaMonitoramento: 'Monitoring Area',
		armasApreendidas: 'Weapons Seized',
		armazenamento: 'Storage',
		armazenamentoDisponivel: 'Storage of available',
		arquivo: 'File',
		arquivosAusentesCorrompidos: 'Missing / Corrupted Files',
		arrasteParaAumentarInferior: 'Drag to increase in size in the lower right corner of the screen',
		arrasteParaMover: 'Drag to move table items',
		as: 'at',
		asTarefasForamAdicionadasComSucesso: 'Tasks have been successfully added',
		asTarefasForamSalvasComSucesso: 'Tasks have been successfully saved',
		asUltimas: 'the last',
		asasFixas: 'Fixed Wings',
		asasRotativas: 'Rotating Handles',
		assinadoDigitalmentePor: 'Digitally signed by',
		assinadoPor: 'Signed by',
		assinadosPorMim: 'Signed by me',
		assinando: 'Signing',
		assinar: 'Sign',
		assinarEFinalizar: 'Sign and Finish',
		assinarESalvarTrecho: 'Subscribe and Save Leg',
		assinarEletronicamente: 'Sign electronically',
		assinarInspetor: 'Inspector\'s signature',
		assinarManualmente: 'Sign manually',
		assinarMecanico: 'Mechanic\'s signature',
		assinarTodosOsTrechos: 'Subscribe to all sections',
		assinarTrecho: 'Sign to excerpt',
		assinatura: 'Signature',
		assinaturaAvalicao: 'The signature must have 8 numeric digits.',
		assinaturaDigialInspetor: 'Digitally signed by inspector',
		assinaturaDigital: 'Digital Signature',
		assinaturaDigitalMecanico: 'Digitally signed by mechanic',
		assinaturaDigitalPilotoComando: 'Digitally signed by the pilot in command',
		assinaturaEletronica: 'Electronic signature',
		assinaturaInvalida: 'Invalid signature.',
		assinaturaMotivo: 'Reason sent successfully!',
		assinaturaOrdem: 'Order Mission signature',
		assinaturaTemQueTer8: 'Signature must have 8 numeric digits',
		ate: 'until',
		ateFiltro: 'to',
		atencaoEspecial: 'Special attention',
		ativa: 'Active',
		ativaEDesativaPrivilegios: 'Here you ENABLE or DISABLE the privileges that will be displayed to the customer.',
		ativar: 'To Activate',
		ativarInspecao: 'Enable Inspection',
		ativarInspecoes: 'To activate this inspection, a justification is required',
		ativarTodas: 'Activate All',
		ativarTodasInspecoes: 'To activate all inspections, a justification is required',
		ativarUsuario: 'Enable User',
		atividade: 'Activity',
		atividades: 'Activities',
		atividadesAereas: 'Air Activities',
		atividadesAereasGeral: 'General Air Activities',
		ativo: 'Active',
		atravesDaBusca: 'through the search bar',
		atualizaDadosFdm: 'Update FDM data',
		atualizacao: 'Update',
		atualizacaoTempoManual: 'Manual time update',
		atualizacoes: 'Updates',
		atualizado: 'Updated',
		atualizando: 'Updating',
		atualizandoLista: 'Updating list',
		atualizandoModelosAeronaves: 'Updating aircraft models',
		atualizandoTempo: 'Updating time',
		atualizar: 'Update',
		atualizarCartao: 'Update Card',
		atualizarCartoes: 'Update Cards',
		atualizarGrupo: 'Update Group',
		atualizarItem: 'Update Item',
		atualizarMapa: 'Update Map',
		atualizarOrdemDeMissao: 'Update Mission Order',
		atualizarOrdemServico: 'Update work order',
		atualizarRoteiro: 'Update Itinerary',
		atualizarSolicitacao: 'Update Request',
		atualizarTrecho: 'Update Leg',
		auditoria: 'Audit',
		auditoriaDiarioDeBordo: 'Daily Onboard Audit',
		ausentes: 'Absent',
		autoLocalizacao: 'Auto Location',
		autonomia: 'Autonomy',
		autorizacao: 'Authorization',
		aval: 'Checks',
		avaliacao: 'Evaluation',
		avaliacaoGeral: 'GENERAL EVALUATION',
		avaliacaoQualitativa: 'Qualitative assessment',
		avaliacaoQualitativaAposAAplicacao: 'Qualitative evaluation after application of the recommendations',
		avaliar: 'Measure',
		avaliarDiscrepancia: 'Discrepancy measure',
		avancado: 'Advanced',
		avancar: 'Next',
		avioesEDisponibilidade: 'Aircraft and Availability',
		avisoDeInicializacao: 'Start-up warning',
		baco: 'Spleen',
		bagagemMao: 'Handbag',
		bagagemPorao: 'Hold baggage',
		bairro: 'Neighborhood',
		baixa: 'Low',
		baixar: 'Download',
		bambiBucket: 'Bambi Bucket',
		bancoDeDados: 'Database',
		base: 'Base',
		baseContratual: 'Contractual Basis',
		baseContratualETransferencia: 'Contractual basis and transfers',
		baseDeOrigem: 'Base of Origin',
		baseOperacional: 'Operational Base',
		basico: 'Basic',
		bastaClicar: 'Just click on the map to add a new point of interest, or click on one on the map to edit it',
		bateria: 'Battery',
		bilhete: 'Ticket',
		bilhetesDeEmbarque: 'Boarding tickets',
		boletins: 'SB',
		botoesEGatilhos: 'Triggers and buttons',
		brigadistas: 'Brigadists',
		buscar: 'Type to search on the list below',
		buscarFatura: 'Search',
		cCarregar: 'LOAD',
		cadComissaria: 'Commissioner registration',
		cadTipoHabilitacao: 'Registration of License Type',
		cadTripulacao: 'Crew Registration',
		cadastrar: 'Register',
		cadastrarImagens: 'Register Images',
		cadastrarNovoDespacho: 'Register new dispatch',
		cadastrarProcedimento: 'Procedure Register',
		cadastro: 'Register',
		cadastroAplicabilidade: 'APPLICABILITY REGISTER',
		cadastroAtividade: 'Activity Log',
		cadastroCliente: 'Customer registration',
		cadastroCombustiveis: 'Fuel Registration',
		cadastroConfigAeronave: 'Aircraft Settings Register',
		cadastroDeBase: 'Base Registration',
		cadastroDeDepartamento: 'Department Registration',
		cadastroDeDocumentacao: 'Documentation Registration',
		cadastroDeFuncoes: 'Registration of Functions',
		cadastroDeOvn: 'NVG Registration',
		cadastroDeSecao: 'Section Registration',
		cadastroDeSessao: 'Session Registration',
		cadastroDeVeiculos: 'Vehicle Registration',
		cadastroFornecedor: 'Supplier Registration',
		cadastroGrupoDePassageiros: 'Passenger Group Registration',
		cadastroLayer: 'Layer Registration',
		cadastroLicenca: 'License Registration',
		cadastroMateriais: 'Materials Registration',
		cadastroMotor: 'Powerplant Registration',
		cadastroPassageiros: 'Passenger Registration',
		cadastroPontosInteresse: 'Points of Interest Register',
		cadastroRotaer: 'Rotaer Registration',
		cadastroTipoArmazenamento: 'Storage Type Register',
		cadastroTipoCarga: 'Load Type Registration',
		cadastroTipoEmbalagem: 'Package Type Register',
		cadastroTipoVeiculo: 'Vehicle Type Registration',
		cadastroUnidadeConservacao: 'Conservation Unit Registration',
		cadastroUnidadeOrcamentaria: 'register Budget Unite',
		cadastroUsuarioSimplificado: 'Simplified User Registration',
		cafeManha: 'Breakfast',
		calculoSistema: 'System Calculation',
		calculosDoImpostos: 'Tax Calculation',
		calendarica: 'Calendar',
		calendaricas: 'Calendars',
		calendario: 'Calendar',
		calendarioDeManutencao: 'Maintenance Calendar',
		calendarioManutencao: 'Maintenance Schedule',
		calendarioSemanal: 'Weekly Calendar',
		calor: 'Heat',
		caminhao: 'Truck',
		camp: 'Camp',
		campo1: 'Field 1',
		campo2: 'Field 2',
		campo3: 'Field 3',
		campo4: 'Field 4',
		campo5: 'Field 5',
		campoObrigatorio: 'This field is required.',
		camposObrigatorios: 'You must enter the required fields.',
		camposOleoLubrificante: 'Lubricating oil fields',
		camposWsdl: 'WSDL fields',
		cancelaOrdemServico: 'Cancel work order',
		cancelada: 'Canceled',
		canceladaComSucesso: 'Successfully Canceled',
		cancelado: 'Canceled',
		cancelados: 'Canceled',
		cancelando: 'Canceling',
		cancelar: 'Cancel',
		cancelarDespacho: 'Cancel Office',
		cancelarDiario: 'Cancel Edit',
		cancelarOrdem: 'Cancel order',
		cancelarOrdemServico: 'Do you want to CANCEL this work order?',
		cancelarSelecao: 'Cancel selection',
		capacidadeMaxima: 'Maximum Capacity',
		capacidadeMaximaMovimentacaoCombustivel: 'Maximum Capacity (l)',
		capacidadeOuPotenciaOuCilindrada: 'Capacity / Power / Cylinder Capacity',
		capitulo: 'Chapter',
		caracteresRestantes: 'characters remaining.',
		carga: 'Cargo',
		cargaExcluidaComSucesso: 'Load successfully deleted',
		cargaHoraria: 'Workload',
		cargaHorariaSemanal: 'Weekly Workload',
		cargaInicial: 'Initial Charge',
		cargaLiquida: 'Net Cargo?',
		cargaSalvaComSucesso: 'Load saved successfully',
		cargaTransportada: 'Cargo Transport',
		cargo: 'Role',
		carregaAutomaticoPerfilAoCriarUsuario: 'Automatically load this profile when creating a new user?',
		carregando: 'Loading',
		carregandoComponentes: 'Loading components',
		carregandoDados: 'Loading data',
		carregandoDadosCAMP: 'Loading CAMP data',
		carregandoDiario: 'Loading logbook',
		carregandoDiarios: 'Loading daily',
		carregandoEntregas: 'Loading deliveries',
		carregandoHorimetro: 'Loading horimetre',
		carregandoListas: 'Loading Lists',
		carregandoMaisOpcoes: 'Loading more options',
		carregandoManutencoes: 'Loading Maintenance',
		carregandoModelo: 'Loading Template',
		carregandoMovimentacoes: 'Loading drives',
		carregandoOrdemServico: 'Loading Service Order',
		carregandoPosicaoDoVoo: 'Loading flight position',
		carregar: 'Load',
		carregarFoto: 'Upload Photo',
		carregarModelo: 'Upload Template',
		carregarPosicaoDoVoo: 'Load flight position',
		carregarVoos: 'Load Flights',
		carrgandoFoto: 'Loading photo',
		cartaDeSituacao: 'Letter of Situation',
		cartaDeSituacaoCalendario: 'Situation Letter',
		cartaDeSituacaoOperacoes: 'Status Chart Operations',
		cartasParaAtualizar: 'Cards to update',
		casaDecimal: 'Requires decimal place',
		casado: 'Married',
		caso: 'Case',
		casoNaoUtilizeDiario: 'If you do not use the logbook to update the manuals, you can enable this option, with this will display a tab \'UPDATES\' on the GENERAL VIEW screen, allowing you to update maintenance manually.',
		casoNenhumaAeronave: 'If no aircraft is selected',
		categoria: 'Category',
		categoriaRegistro: 'Register Category',
		celula: 'Airframe',
		centralizar: 'Centralize',
		centroCusto: 'cost center',
		centroDeCustos: 'Cost Center',
		cep: 'Zip Code',
		ceso: 'Risk Mangment',
		cfg: 'Configuration',
		chamada: 'Call',
		chamadaDeSuporte: 'Support Call',
		chamadoConcluido: 'Call Completed',
		chamadoSuporte: 'Support',
		chassi: 'Car Chassis',
		chaveApi: 'Api Key',
		chaveDaNFE: 'Invoice Key',
		chaveNFE: 'Invoice Key',
		chaveServices: 'Key in Services',
		checkIn: 'checkin',
		chegada: 'Arrival',
		cicloDeTorque: 'Cycle Torque',
		cicloTorque: 'Torque Cycle',
		ciclos: 'Cycles',
		ciclosNF: 'NF Cycles',
		ciclosNG: 'NG Cycles',
		ciclosNP: 'NP Cycles',
		ciclosTorque: 'Torque Cycles',
		ciclosTotais: 'Total Cycles',
		ciclosTotaisManutencao: 'Total Maintenance Cycles',
		ciclosTotaisMotor: 'Total Engine Cycles',
		cidade: 'City',
		cidadeDeVerificacao: 'Verification City',
		classificacao: 'Classification',
		classificacaoAtualizada: 'Classification updated',
		classificacaoDesativada: 'Rating disabled',
		classificacaoESub: 'Classification and Subclassification',
		classificacaoExcluida: 'Classification excluded',
		classificacaoSalva: 'Classification Added',
		clickAquiParaAnexar: 'Click here to attach',
		clickExibirApp: 'Click here to access the Followair of your phone.',
		clickParaVerOsTrechosAgrupados: 'Click to see flights grouped',
		clickParaVerOsTrechosPor: 'Click to see flights grouped by',
		clienteAtualizado: 'Updated Client',
		clienteSolicitante: 'Requesting Customer',
		clientesSolicitantes: 'Requesting Customers',
		cliqueAqui: 'Click Here',
		cliqueEmAlgumaImagem: 'Click on any image',
		cliqueEmCarregar: 'Click load after typing',
		cliqueEmNovoParaAdicionar: 'Click on \'new\' to add',
		cliqueNoHistoricoParaCarregar: 'Click history to upload.',
		cliqueParaAnexar: 'CLICK HERE TO ATTACH',
		cliqueParaConcluir: 'Click to finish',
		cliqueParaRemover: 'Click to remove',
		cliqueParaVerAAssinatura: 'Click to view the signature',
		cliqueTrechoCarregar: 'Click the snippet to load it.',
		cnpj: 'CNPJ',
		codigo: 'Code',
		codigoClassificacao: 'Classification code',
		codigoDaSolicitacao: 'request code',
		codigoDoProduto: 'Product Code',
		codigoGeradoAoSalvar: 'Code generated on save',
		codigoGerenciamentoDeRisco: 'Risk mangment code',
		codigoInterno: 'Internal code',
		codigoRenavan: 'Renavan Code',
		codigoSituacao: 'Code - Situation',
		codinome: 'Codename',
		coluna: 'Column',
		com: 'With',
		comUmLink: 'with a link to retrieve your password!',
		comandante: 'Commander',
		comandanteLocalMissao: 'Mission Commander on-site',
		combustivel: 'Fuel',
		combustivelConsumido: 'Consumed Fuel',
		combustivelInicial: 'Initial Fuel',
		combustivelTotal: 'Total Fuel',
		comissario: 'Commisioner',
		comissarios: 'commissioner',
		comoDesejaFiltar: 'Choose form you\'d like to filter',
		complemento: 'Complement',
		completo: 'Entire',
		componenteCargaSolicitacao: 'Component Cargo Request',
		componentePassageiroSolicitacao: 'Component passenger request',
		componenteTrechoSolicitacao: 'Request Stretch Component',
		componentes: 'Components',
		comprovanteAbastecimento: 'Supply Voucher',
		computadorDeBordo: 'Board computer',
		comunicacaoESO: 'Risk mangment',
		comunicacoes: 'Communication',
		concluiEssaInspecao: 'I Concluded this Inspection',
		concluida: 'Completed',
		concluido: 'Completed',
		concluidoPor: 'Completed by',
		concluidos: 'Concluded',
		concluir: 'Complete',
		concluirDiscrepancia: 'Conclude Discrepancy',
		concluirOrdemDeServico: 'Complete work order',
		conclusao: 'Conclusion',
		concordoComOsTermosDeUso: 'I AGREE TO THE TERMS OF USE',
		conferencia: 'Conference',
		configBackend: 'Backend Configuration',
		configuracao: 'Settings',
		configuracaoAeronave: 'Settings Airplan',
		configuracoes: 'Settings',
		configuracoesEscala: 'Scale Settings',
		configuracoesSalvas: 'Saved settings',
		confirmaExclusaoLeitores: 'This action will exclude the required readers already inserted, do you want to continue?',
		confirmaLeitura: 'Confirm reading',
		confirmaLeituraDocumento: 'Do you confirm the reading of the document?',
		confirmando: 'Confirming',
		confirmar: 'Confirm',
		confirmarAssinatura: 'Confirmed new signature',
		confirmarDuplicar: 'Confirms you want to duplicate',
		confirmarNewPassword: 'Confirmed new password',
		confirmeDadosAeronave: 'Confirm that the aircraft and engine data are correct',
		conjuge: 'Spouse',
		consultarNota: 'Load Invoice',
		consumados: 'Finished',
		consumidoOValorTotalDoContrato: 'Total contract value was consumed',
		consumidoOValorTotalDoEmpenho: 'The total amount of effort was consumed',
		consumivel: 'Consumable?',
		consumo: 'Consumption',
		consumoDeCiclos: 'CYCLE CONSUMPTION',
		consumoTotal: 'Total Consumption',
		contador: 'count',
		contato: 'Contact',
		contatoDeEmergencia: 'Emergency contact',
		contatoEmCasoDeEmergencia: 'Emergency Contact',
		contatosMissao: 'Mission Contacts',
		contexto: 'Context',
		contextoAtualizado: 'Updated operational context',
		contextoExcluido: 'Operational Context deleted.',
		contextoOperativo: 'Operating Context',
		contextoSalvo: 'Operational Context Saved',
		continuar: 'Continue',
		contrato: 'Contract',
		contratoAtualizadoComSucesso: 'Contract successfully updated',
		contratoEmpenhoMovimentacao: 'This contract already has a effort or is related to a movement of fuel!',
		contratoExcluidoComSucesso: 'Contrat successfully deleted',
		contratoSalvoComSucesso: 'Contract successfully saved',
		contratos: 'Contracts',
		contratosAbastecimentos: 'Supply Contracts',
		contratosGenericos: 'Generic Contracts',
		contratosSBH: 'SBH Contracts',
		controlado: 'Controlled',
		controle: 'Controller',
		controleDeInpencoesEManuais: 'Inspection and Manual Control',
		controleDeInspecao: 'Inpections Control and Manual',
		controleDePassageirosECargas: 'Passenger and cargo control',
		controleHorasEMotor: 'TIME CONTROL AND ENGINE CYCLES',
		controleHorasOvn: 'Night Vision Glasses Time Control',
		controleInpencoesComponentes: 'Control of Inspections and Components',
		copiandoDiario: 'Copying logbook',
		copiar: 'Copy',
		copiarDespacho: 'Copy the last dispatch',
		copiarOrdem: 'Copy the last order',
		copiarPessoas: 'Copy people',
		copiarSolicitacao: 'Copy the last request',
		copiloto: 'Copilot',
		cor: 'Color',
		corIdentificacao: 'identification color',
		corPolilyne: 'Color Polilyne',
		corPredominante: 'Predominant Color',
		coracao: 'Heart',
		cornea: 'Cornea',
		corrijaCamposVermelho: 'Correct the fields in red',
		corrijaOsCamposEmVermelho: 'Correct the fields in red',
		corrompidos: 'Corrupted',
		corte: 'Cut',
		corteVoo: 'Deactivation',
		cotacao: 'Quotation',
		cpfInvalido: 'Invalid ID',
		cpfInvalidoOuJaCadastradoNoSistema: 'Invalid ID or already registered in the system',
		cpfJaCadastrado: 'ID already registered.',
		cpfUsadoComoLoginEsenha: 'The ID number will be used as LOGIN and PASSWORD, which must be changed on the first access.',
		crea: 'CREA',
		criar: 'Add',
		criarModeloPadrao: 'Create a Standard Model',
		critica: 'Criticism',
		cumpridoConformeDocumentacaoReferencia: 'Complying with Reference Documentation.',
		curso: 'Training',
		custo: 'Cost',
		custoDoCiclo: 'Cycle cost',
		custoHora: 'Hourly cost',
		daAeronve: 'Graphics',
		daProgramação: 'Of Schedule',
		dac: 'DAC',
		dadosDaMissao: 'Mission Facts',
		dadosDaMissaoPreenchidos: 'All the data in the mission order has been filled, it is waiting for execution.',
		dadosDaPrevencao: 'Prevention Data',
		dadosDeDestino: 'Target Data',
		dadosDeEmissao: 'Emission Data',
		dadosDeEntrega: 'Delivery Data',
		dadosDeMonitoramento: 'Dados de Monitoramento do Motor e Abastecimento de Óleo',
		dadosDoCliente: 'Client\'s Data',
		dadosDoContrato: 'Contract Data',
		dadosDoDespacho: 'Dispatch Information',
		dadosDoVoo: 'Flight data',
		dadosFornecedor: 'Supplier Data',
		dadosGerais: 'General Data',
		dadosKit: 'Kit Data',
		dadosMotor: 'Powerplant data',
		dadosOleoEdicaoMecanico: 'The information regarding the lubricating oil was edited by the mechanic',
		dadosProgramacaoVoo: 'Flight Schedule Data',
		dadosdeEntregaDaNFe: 'Invoice Delivery Data',
		dashboardDadosSistema: 'System Data Dashboard',
		data: 'Date',
		dataAbertura: 'Opening data',
		dataAberturaCadastro: 'Date',
		dataAcesso: 'Access date',
		dataAtualMaiorUltimoTrecho: 'The current date is greater than the last portion of the mission order.',
		dataAtualizacao: 'Update date',
		dataCE: 'CE Date',
		dataCadastroOvn: 'NVG Register Date',
		dataCompra: 'Purchase date',
		dataConclusao: 'Date Completed',
		dataCotacao: 'Quotation date',
		dataCriacao: 'Creation Date',
		dataDaConclusao: 'Completion date',
		dataDaNFE: 'Invoice Date',
		dataDaOcorrencia: 'Occurrence date',
		dataDaSolicitacao: 'Requested Date',
		dataDeConclusao: 'Date of the conclusion',
		dataDeInspecao: 'Inspection Date',
		dataDeVerificacao: 'Verification Date',
		dataDiario: 'Daily Date',
		dataDoDiarioDeBordo: 'Logbook Date',
		dataDoMB1A2: 'Date MB1A2',
		dataDoPagamento: 'Pay Day',
		dataDoRecebimentoFisico: 'Date Physical Receipt',
		dataEmissao: 'Date of issue',
		dataEmissaoNotaFiscal: 'Invoice Issue Date',
		dataEncerramento: 'Closing Date: ',
		dataEstimada: 'Estimated Due',
		dataExecucao: 'Execution Date',
		dataFabricacao: 'Data de fabricación',
		dataFim: 'End date',
		dataFimIndisponibilidade: 'End date of unavailability',
		dataHoraCadastro: 'Date-Time Registration',
		dataHorimetro: 'Data Hour Meter',
		dataHorimetroAtual: 'Current Time Meter',
		dataInicio: 'Start date',
		dataInicioCarga: 'Start date of first charge',
		dataInicioIndisponibilidade: 'Unavailability start date',
		dataInicioOvn: 'NVG Start Usage Date',
		dataInvalida: 'Invalid Date',
		dataLeitura: 'Date of reading',
		dataLimite: 'Deadline',
		dataManutencao: 'Maintenance Date',
		dataNascimento: 'Birthday',
		dataPrevisao: 'Forecast Date: ',
		dataProcessamento: 'Data Processing',
		dataProximaInspecao: 'Next inspection date',
		dataReportada: 'Reported Date',
		dataServico: 'Service date',
		dataSolicitacao: 'Request Date',
		dataTermino: 'End Date',
		dataTolerancia: 'Tolerance date',
		dataUltimaInspecao: 'Last inspection date',
		dc: 'dc',
		de: 'Of',
		deTrabalho: 'Work',
		decimal: 'Decimal',
		decimo: 'Tenth',
		decolagem: 'Take-off',
		decolagemPrevista: 'Scheduled takeoff',
		decolagemPrevisto: 'Scheduled takeoff',
		defasagemVorI: 'VOR I Lag',
		defasagemVorII: 'VOR II Lag',
		definirComoPlanoDeFundo: 'Set As Background',
		definirOperador: 'Define Operator',
		definirPlanoDeFundo: 'Set Background',
		delito: 'Crime',
		demandaReprimida: 'Pent-up Demand',
		densidade: 'Density',
		departamento: 'Department',
		departamentoSolicitante: 'requesting department',
		desabilitado: 'disabled',
		desabilitar: 'Disable',
		desabilitarInspecao: 'Disable Inspection',
		desagrupando: 'Ungrouping',
		desagruparTrechos: 'Ungroup Leg',
		desativadoComSucesso: 'Successfully deactivated',
		desativar: 'Disable',
		desativarInspecao: 'Disable Inspection',
		desativarInspecoes: 'To disable this inspection, a justification is required',
		desativarTodas: 'Deactivate all',
		desativarTodasInspecoes: 'To disable all inspections, a justification is required',
		desativarUsuario: 'Disable User',
		desconto: 'Discount',
		descricao: 'Description',
		descricaoAlijamentosCarga: 'Description of cargo dumps',
		descricaoAnp: 'Description ANP',
		descricaoCapitulo: 'Chapter description',
		descricaoCompleta: 'Full description',
		descricaoDaCarga: 'Cargo Description',
		descricaoDaMissao: 'Description of the Mission',
		descricaoDaOrdem: 'Order Description',
		descricaoDoExercicio: 'Exercise Description',
		descricaoDoLocal: 'Location Description',
		descricaoDoTema: 'Theme Description',
		descricaoDosFatos: 'Description of the facts',
		descricaoLavagemCompressor: 'Compressor wash description',
		descricaoLayer: 'Description for the layer',
		descricaoOrdemDeMissao: 'Mission Order Description',
		descricaoOrdemMissaoExcluidoComSucesso: 'Mission Order Description deleted correctly.',
		descricaoOrdemMissaoSalvoComSucesso: 'Mission Order Description successfully saved.',
		descricaoProduto: 'Product Description',
		descricaoResumida: 'Short Description',
		descricaoServico: 'Service Description',
		descricaoStatus: 'Status',
		descricaoTipoArmazenamento: 'Storage Type Description',
		descricaoUnidadeCompra: 'Budget purchase unit',
		desdeOInicio: 'since the beginning of the operation in the month',
		desejaAdicionarAssinaturaPorLogin: 'Do you want to add subscription by login',
		desejaAssinarEsseTrecho: 'Do you want to Sign this excerpt',
		desejaAtivarEsseUsuario: 'Do you want to enable this User?',
		desejaAtualizarTrecho: 'Do you want to update this leg?',
		desejaCancelarDiscrepancia: 'want to cancel this discrepancy',
		desejaCancelarEssePedido: 'Do you want to cancel this order',
		desejaCancelarPrevencao: 'Do you want to CANCEL this prevention?',
		desejaCancelarSolicitacao: 'Do you want to cancel this request?',
		desejaCancelarTicket: 'Do you want to CANCEL this Ticket?',
		desejaConcluirDiscrepancia: 'want to finish this discrepancy',
		desejaConcluirEssaDiscrepancia: 'Do you want to complete this discrepancy?',
		desejaConfirmarExclusaoNota: 'Do you want to delete this invoice?',
		desejaConfirmarVerificacaoNota: 'Do you want to verification this invoice?',
		desejaContinuarAPrrencher: 'Do you wish to continue filling in this logbook?',
		desejaDesativarEsseUsuario: 'Do you want to disable this User?',
		desejaEncerrarEssaOrdemDeMissao: 'Do you want to terminate this mission order?',
		desejaEncerrarEssaProgramacaoVoo: 'Do you want to terminate this flight schedule?',
		desejaEncerrarEsseDespacho: 'Do you want to close this dispatch',
		desejaExcluir: 'Do you want to delete',
		desejaExcluirACarga: 'Do you want to delete the load',
		desejaExcluirADocumentacao: 'Do you want to delete the documentation',
		desejaExcluirAcesso: 'Do you want to delete the access?',
		desejaExcluirCategoria: 'Do you want to delete the category?',
		desejaExcluirClassificacao: 'Do you want to delete this Classification?',
		desejaExcluirContexto: 'Do you want to Exclude this Operating Context?',
		desejaExcluirEmbalagem: 'Do you wish to exclude this Packaging?',
		desejaExcluirEssaLeitura: 'Do you want to delete this required read?',
		desejaExcluirEssaPermissao: 'Do you really want to delete this permission?',
		desejaExcluirEssaSolicitacao: 'Do you want to delete this request?',
		desejaExcluirEsse: 'Do you want to delete this',
		desejaExcluirEsseDespacho: 'Do you want to delete this dispatch?',
		desejaExcluirEsseDocumento: 'Do you want to delete this document?',
		desejaExcluirEsseEmpenho: 'Do you want to delete this effort',
		desejaExcluirEsseItem: 'Do you want to delete this item',
		desejaExcluirEsseLayer: 'Do you want to delete this layer?',
		desejaExcluirEsseProcedure: 'Do you want to delete this procedure?',
		desejaExcluirEsseProduto: 'Do you want to delete this product',
		desejaExcluirEsseProdutoServico: '¿Quieres eliminar este producto/servicio?',
		desejaExcluirEsseTrecho: 'Do you want to delete this Leg?',
		desejaExcluirFornecedor: 'Do you want to delete this provider?',
		desejaExcluirOTipoDeSolicitacao: 'Do you want to delete the request type',
		desejaExcluirPontoInteresse: 'Do you want to delete the point of interest',
		desejaExcluirSubclassificacao: 'Do you want to delete this subclass?',
		desejaExcluirUnidadeMedida: 'Do you want to delete this Unit of Measure?',
		desejaExluirContrato: 'Do you want to delete this contract?',
		desejaFinalizarTrecho: 'Do you want to end this leg?',
		desejaGerarFatura: 'Do you want to generate an invoice for that invoice',
		desejaReabrirEssaOrdemMissao: 'Do you want to open this Mission Order?',
		desejaRetornarOrdemMissaoExecucao: "Do you want to return this Mission Order to 'Running'?",
		desejaSelecionarvoo: 'Use a mesh flight model?',
		desejada: 'Desired',
		desejaexcluirEmpenho: 'Do you want to exclude this commitment:',
		desembarque: 'N°LANDING',
		desenvolvedorVejaOErroRetornadoPeloBackEnd: 'Developer, see error returned by backend',
		designativo: 'Designative',
		desmarcarTodos: 'Deselect all',
		desmarqueTrechosCarg: 'Uncheck the sections that the load will not go',
		desmarqueTrechosPass: 'Uncheck the sections that the passenger will not go',
		despacho: 'Dispatch',
		despachoAeronaves: 'Aircraft Dispatch',
		despachoDeAeronaves: 'Aircraft Dispatch',
		despachoEmergencial: 'Emergency Dispatch',
		despachoExcluido: 'Excluded Order',
		despachoGerado: 'Program generated successfully',
		despachoReaberto: 'Office Reopened.',
		despachoSalvo: 'Dispatchs Saved',
		despachos: 'Dispatchs',
		despachosGerados: 'Orders Generated',
		destinatario: 'Addressee',
		destinatarios: 'Addressee',
		destino: 'destination',
		destinoAproximado: 'Approximate Destination',
		detalhar: 'Detail',
		detalhes: 'Details',
		detalhesDaProgramacao: 'Schedule Detail',
		detalhesDoPagamento: 'DETAIL OF PAYMENT',
		detalhesDoProduto: 'Product Details',
		determinacaoSessaoManutencao: 'As determined by the maintenance session',
		deveConterMininoUm: 'Must contain at least 01',
		devolucaoPrevista: 'Expected Return',
		devolvidoEm: 'Returned on',
		diaAnterior: 'Last day',
		diagonal: 'Diagonal',
		diarias: 'Daily',
		diario: 'Daily',
		diarioDeBordo: 'Logbook',
		diarioDeBordoMecanico: 'Mechanical Logbook',
		diarioDeBordoOperador: 'Daily Logger Operator',
		diariosDeBordoNaoAssinados: 'Non-signed Logbooks',
		dias: 'days',
		diasMaisComuns: 'Common days',
		diasRestantes: 'Days remaining',
		diferencaUTC: 'Difference from UTC',
		digiteANovaAssinatura: 'Enter the new signature in the field below',
		digiteNovaSenhaAbaixo: 'Enter the new password in the field below.',
		digiteOItemQueDesejaBuscar: 'Enter the item you want to search',
		digiteParaBuscar: 'Type to search',
		digiteParaRealizarUmaBuscaAvancada: 'Enter to perform an advanced search',
		digiteSeuLogin: 'Enter your login.',
		digiteSuaAssinatura: 'Enter your signature',
		digiteSuaSenhaParaRenovala: 'Enter your password to renew it.',
		direcao: 'Direction',
		disciplina: 'Discipline',
		disciplinaAtualizada: 'Updated course',
		disciplinaInserida: 'Discipline inserted',
		discrepancia: 'discrepancy',
		discrepanciaConcluida: 'Discrepancy Completed',
		discrepanciaSalva: 'Discrepancy Saves',
		discrepancias: 'Discrepancies',
		discrepanciasTecnicas: 'Technical Discrepancies',
		discrepanciasVerificadas: 'Discrepancies Checked',
		disponibilidade: 'Availability',
		disponibilizarAeronave: 'Make Aircraft Available',
		disponivel: 'Available',
		disponivelNa: 'Available in',
		disponivelParaRetorno: 'Available for Return',
		distancia: 'Distance',
		distanciaCalculada: 'Calculated Distance',
		distanciaEmNM: 'Distance in NM',
		distanciaTotal: 'Total Distance',
		diurno: 'Daytime',
		divorciado: 'Divorced',
		doArtigo: 'ART. 4 OF RESOLUTION 457',
		doContrato: 'of the contract',
		documentacao: 'Documentation',
		documentacaoExcluidaComSucesso: 'Documentation successfully deleted',
		documentacaoSalva: 'Documentation Saved',
		documento: 'Document',
		documentoExcluidoComSucesso: 'Document successfully deleted.',
		documentoLeituraObrigatoria: 'Mandatory reading document',
		documentoObrigatorioExiste: 'The mandatory document already exists in the system',
		documentoS: 'Documents',
		documentoSalvoComSucesso: 'Document successfully saved',
		documentos: 'Document(s)',
		documentosArmazenados: 'Stored Documents',
		documentosSemDuplicidade: 'CPF and Passport are the only documents that prevent duplicate registrations',
		dois: 'Two',
		dosUltimos: 'the last',
		download: 'Download',
		downloadAnexo: 'Download Attachment',
		duplicar: 'Duplicate',
		duracao: 'Duration',
		duracaoPrevistaJornada: 'Expected workday duration',
		duracaoPrevistaVoo: 'Expected duration of Flight',
		e: 'and',
		eEstrangeiro: 'Is foreign',
		eImportanteFazerEsseProcedimento: 'It is important to do this procedure before the aircraft starts to fly',
		eNecessario: 'needs to generate an invoice',
		eOperador: 'is the operator',
		eUsuario: 'and User',
		edicao: 'Edition',
		editadoMecanico: 'Edited Mechanic',
		editar: 'Edit',
		editarCapitulo: 'Edit Chapter',
		editarCategoria: 'Edit Category',
		editarDiario: 'Edit Log',
		editarHabilitacao: 'Edit license',
		editarMalha: 'edit mesh',
		editarTrecho: 'Edit Leg',
		editarUsuarioSimplificado: 'Edit Simplified User',
		editaveis: 'Editable',
		efetividade: 'Effectiveness',
		em: 'in',
		em2: 'at',
		emAberto: 'Opened',
		emAnalise: 'In analysis',
		emAndamento: 'IN PROGRESS',
		emBrancoMantemAssinatura: 'In blank, keep the same signature',
		emEstoque: 'In stock',
		emExecucao: 'Running',
		emExecucaoOuAberta: 'Running or open',
		emExecucaoVencida: 'In overdue execution',
		emHoras: 'In hours',
		emMeses: 'In Months',
		emMesesDias: 'in Months and Days',
		emMonitoramento: 'In monitoring',
		emMovimento: 'In Movement',
		emTolerancia: 'in tolerance',
		emUso: 'in use',
		email: 'E-mail',
		emailAnac: 'E-mail ANAC',
		emailInvalido: 'Invalid email.',
		emailJaCadastrado: 'E-mail already registered.',
		emailObrigatorio: 'Required email',
		embalagemExcluidaComSucesso: 'Pagackage sucessfully deleted',
		embalagemJaCadastrada: 'Package already registered',
		embarcou: 'Boarded',
		embarque: 'Boarding',
		emergencia: 'Emergency',
		emergencial: 'Emergency',
		emissao: 'Emission',
		empenho: 'Effort',
		empenhoExcluidoComSucesso: 'Endeavor successfully deleted',
		empenhoSalvoComSucesso: 'Commitment saved successfully',
		empenhos: 'Efforts',
		empresa: 'Company',
		empresaEstrangeira: 'foreign company',
		encaminharParaExecucao: 'Forward the order to execute',
		encerrada: 'Closed',
		encerramento: 'Closing',
		encerrar: 'Close',
		encontrados: 'Found ',
		end: 'Address',
		endereco: 'Address',
		enderecoFuncional: 'Functional address',
		enderecoResidencial: 'Home address',
		enfermeiro: 'Nurse',
		ensino: 'educational',
		ensinoInfantil: 'Preschool',
		ensinoSuperior: 'Higher Education',
		enterSalvaEscCancela: 'ENTER to save and ESC to cancel',
		entrada: 'Entry',
		entradaEfetuada: 'Checked in',
		entradaRegistrada: 'Registered entry',
		entreEmContatoConosco: 'Contact us',
		entregar: 'Give',
		entregarSuprimentos: 'Deliver supplies',
		entregue: 'Delivered',
		enviaMensagem: 'Send Message',
		enviamosUmEmail: 'We send you email',
		enviando: 'Sending',
		enviandoSuprimentos: 'Shipping supplies',
		enviar: 'Send',
		enviarArquivos: 'Send files',
		enviarSolicitacao: 'Send request',
		envioNotificacoes: 'Sending Notifications',
		envolvidos: 'Involded',
		equipamento: 'Equipment',
		equipamentoTrocado: 'Equipment Changed',
		equipamentos: 'Equipments',
		equipe: 'Team',
		erroAoNotificar: 'Notifying Error',
		erroConectarServidor: 'Error connecting to the server.',
		erroHorimetro: 'Hourmeter not filled in aircraft registration',
		erroVor: 'Error(degrees)',
		esclero: 'Scleroderma',
		escola: 'School',
		escolaDeVoo: 'School of Flight',
		escolaridade: 'Education',
		escolha: 'Choose',
		escolhaAFuncaoTripulante: 'Choose the function of this crew member',
		escolhaAOrigem: 'Choose the source',
		escolhaData: 'Choose a date',
		escolhaOMotivoCancelamentoOrdem: 'Choose the reason for canceling the request',
		escolhaOpcaoAbaixo: 'Choose an action below',
		escolhaPeloMenosUmTrecho: 'Choose at least one segment per passenger',
		escolhaPeloMenosUmTrechoCarga: 'Choose at least one segment per charge',
		escolhaUmEmpenhoParaOCampoValorSerLiberado: 'Choose a commitment for the value field to be released',
		escolhaUmTrechoParaCopiar: 'Choose a leg for you to copy.',
		escolhaUmaAcao: 'Choose an action above.',
		escolhaUmaClassificacaoPara: 'Choose a Classification<br/> to display the list.',
		escolhaUmaOpcaoAoLado: 'Choose an option from the menu next.',
		escolhaUmaTabelaDoBancoDeDadosNaLista: 'Choose a database table from the list',
		escolhaaTurma: 'Choose Class',
		escolhaoAluno: 'Choose the Student',
		escolhaoCurso: 'Choose Training',
		escolherItemAcima: 'You have to choose one or more items above.',
		esconderConcluidos: 'Hide Completed',
		esconderDetalhes: 'Hide details',
		esconderItens: 'Hide items',
		escritorio: 'Office',
		esfera: 'Sphere',
		espacoEmDisco: 'Disk Space',
		espacoEmDiscoUtilizado: 'Used Disk Space',
		especieOuTipo: 'Species/Type',
		esqueceuSuaSenha: 'Forgot your password?',
		esqueciMinhaSenha: 'I forgot my password',
		essaDocumentacaoTemValidade: 'This documentation has expiration',
		essaOrdem: 'This Order',
		essaOrdemNaoPossui: 'This order DOES NOT HAVE signature',
		essaOrdemPossui: 'This order HAS signature',
		essaSolicitaoTemAvalManutencao: 'Does the maintenance approve this request?',
		essaSolicitaoTemOaval: 'Does the Operation approve this request?',
		esseCampoObrigatorio: 'This field is required',
		esseDiarioDeBordoNaoEstaIntegroEntreEmContatoComOSuporte: 'This logbook is not complete, please contact support.',
		esseGrupoExige: 'This group requires the signature of the inspector',
		esseMes: 'This Month',
		esseTrechoNaoPodeSerPreenchido: 'This leg can not be completed now',
		essesDados: 'These data',
		estaExibindo: 'is showing',
		estaPreenchendoUmDiarioDeBordo: 'is keeping a diary for this aircraft.',
		estado: 'State',
		estadoCivil: 'Civil Status',
		estadoDeVerificacao: 'Verification Status',
		estadoDoItem: 'Item status',
		estagiario: 'Intern',
		estavaAtualizado: 'Was updated',
		esteCampoEObrigatorio: 'This field is required',
		estePerfilEhTripulante: 'This profile is crew member',
		estoque: 'Stock',
		estoqueDisponivelSuprimentos: 'Available: NEW, USED, REPAIRED AND OVERHAUL',
		estoqueQuantidadeMinima: 'Minimum quantity of product in stock.',
		estoqueTotalSuprimentos: 'Total stock, including DISPOSED AND DEFECTIVE',
		estoqueUnidadeMedida: 'Inventory - Units of Measure',
		estouCiente: 'I know',
		estouCienteQuanto: 'I AM AWARE ABOUT THE INFORMATION THAT THE',
		etiqueta: 'Label',
		evento: 'Event',
		excelParaCompra: 'Excel for purchase',
		excelente: 'EXCELLENT',
		excluida: 'Deleted',
		excluidoComSucesso: 'Deleted successfully.',
		excluindo: 'Excluding',
		excluir: 'Delete',
		excluirAtualizacao: 'Delete Update',
		excluirContrato: 'Delete Contract',
		excluirFatura: 'Delete Invoices',
		excluirFoto: 'Delete Photo',
		excluirImagem: 'Delete Image',
		excluirLicenca: 'Do you want to delete this license?',
		excluirPontoInteresse: 'Delete point of interest',
		excluirProcedimento: 'Delete Procedure',
		excluirUsuario: 'Excluding user',
		exclusaoLeitores: 'Exclusion of mandatory readers',
		execucao: 'Execution',
		executado: 'Executed',
		exercicio: 'EXERCISE',
		exercicios: 'Exercises',
		exibeAnuncio: 'Displays Ads',
		exibicao: 'Display',
		exibir: 'Show',
		exibirConcluidos: 'View Completed',
		exibirDadosDiarioBordo: 'The data will be filled in after filling in the EC and aircraft number according to the logbook',
		exibirDesativados: 'Display disabled',
		exibirEncerradas: 'Display closed',
		exibirLegendas: 'View Captions',
		exibirTodas: 'Show All',
		existemCampoDaAeroASerem: 'There are fields to fill in the aircraft used.',
		experienciaRecente: 'Recent Experience - Last 90 days',
		experienciaTotal: 'Total Experience',
		exportacaoDados: 'Export Data',
		exportar: 'Export',
		exportarJSON: 'Export JSON',
		extrato: 'Extract',
		extratoDiarioDeBordo: 'LogBook Extract',
		fabricacao: 'manufacturing',
		fabricante: 'Fabricator',
		fabricanteAtualizado: 'Fabricator Updated',
		fabricanteInserido: 'Fabricator Added',
		faltaPagar: 'Still have to pay',
		farol: 'Lighthouse',
		fatorContribuinte: 'Contributing Factor',
		fatura: 'INVOICE',
		faturaEmAberto: 'APERTURE INVOICE',
		faturaFechadaPor: 'INVOICE CLOSED BY',
		faturaSBH: 'SBH Invoice',
		faturas: 'invoices',
		favorPreencherCamposEmVermelho: 'Please fill in the field (s) in red!',
		fechaExercicio: 'CLOSE EXERCISE',
		fechado: 'Closed',
		fechar: 'Close',
		fecharDadosDaAeronave: 'Close aircraft data',
		fecharOrdemDeMissao: 'Close the mission order',
		fem: 'Female',
		fichaCadastralFuncional: 'Funcional Registration Form',
		figado: 'Liver',
		filtrar: 'Filter',
		filtrarPorNome: 'Filter by name: ',
		filtrarPosicoes: 'Filter positions',
		filtro: 'Filter',
		filtroPor: 'Filter by:',
		fim: 'End',
		final: 'Final',
		finalidade: 'finality',
		finalizadoPor: 'Finished',
		finalizar: 'Finish',
		finalizarOrdemDeServico: 'Finish Work Order',
		finalizarTracho: 'Finish Leg',
		foiAtivado: 'Has been activated',
		foiGeradoUmCodigo: 'An order of mission with code was generated',
		forcarAssinarTermo: 'Force sign term?',
		forma: 'Payment',
		formaDePagamento: 'Form of payment',
		fornecedor: 'Provider',
		fornecedorCombustivel: 'Fuel Supply',
		fornecedores: 'Suppliers',
		foto: 'Picture',
		fragil: 'Fragile',
		frequencia: 'Frequency',
		funcao: 'Function',
		funcaoABordo: 'Onboard Function',
		funcaoComoTripulante: 'Function with Crew Member',
		funcaoNaEmpresa: 'Function in Company',
		funcoes: 'Functions',
		fusoHorario: 'Timezone',
		galao: 'Gallon',
		gancho: 'Hook',
		ganchos: 'Hooks',
		gerais: 'General',
		geral: 'General',
		gerando: 'Generating',
		gerandoDespacho: 'Generating dispatch of the week',
		gerandoRelatorio: 'Generating Report',
		gerandoRelatorioDemorar: 'Generating Report(this may take a while)',
		gerar: 'Generate',
		gerarDespacho: 'Generate dispatch',
		gerarDespachoAvulso: 'Generate separate order',
		gerarDespachoSemana: 'Generate dispatch of the week',
		gerarDiarioBordo: 'Generate logbook',
		gerarExcel: 'Generate Excel',
		gerarFatura: 'Invoice Generate',
		gerarMapa: 'Generate Map',
		gerarNotas: 'Generate Notes',
		gerarOrdem: 'Generate order',
		gerarOrdemDeServico: 'Generate Service Order?',
		gerarOrdemMissao: 'Generate Mission Order',
		gerarOrdemServico: 'Generate Work Order',
		gerarPrevencao: 'Generate Prevention',
		gerarProgramacaoDeVoo: 'Generate flight schedule',
		gerarProgramacaoVoo: 'generate schedule',
		gerarRelatorio: 'Generate report',
		gerenciamentoDeRisco: 'Risk mangment',
		gerenciamentoDeRiscoRecomendacao: 'Risk Management Recommendation',
		gerenciamentoTrecho: 'Stretch Management',
		gerenciamentoVoo: 'Flight Management',
		gestao: 'Management',
		gestaoAbastecimento: 'Supply Management',
		gestaoAeronave: 'Aircraft Management',
		gestaoDe: 'Management',
		gestaoDeContratos: 'Contract Management',
		gestaoDeMalha: 'Mesh management',
		gestaoInterna: 'Internal Management',
		gestaoLayer: 'Layers Managemen',
		graficos: 'Graphics',
		grau: 'GRADE',
		grauDeRelacionamento: 'Degree of Relationship',
		graus: 'Degrees',
		grupo: 'Group',
		grupoDePassageiro: 'Passengers Group',
		grupoDePassageiroSalvoComSucesso: 'Passengers group successfully saved.',
		grupoDePassageiros: 'Passengers group',
		grupoDePassageirosAtualizadoComSucesso: 'Passengers Group successfully updated.',
		grupoDePassageirosExcluidoComSucesso: 'Passengers Group successfully deleted',
		grupoDePassageirosSalvoComSucesso: 'Passengers Group successfully saved.',
		grupoOrgaos: 'Organs Group',
		grupos: 'Groups',
		guarnicao: 'Garrison',
		guincho: 'Winch',
		hAssinatura: 'Signature',
		hNotificacao: 'Notifications',
		haCargaASerTransportada: 'Is there cargo to be transported?',
		haContextoOperativo: 'Is there an operational context?',
		haNecessidadeDeAbastecimento: 'Is there a need for refueling?',
		haNecessidadeDeAlmoco: 'Lunch',
		haNecessidadeDeCafeManha: 'Breakfast',
		haNecessidadeDeDiarias: 'Is there a need for daily commitment?',
		haNecessidadeDeJantar: 'Dining',
		haPassageiros: 'Are there Passengers?',
		haResalvasNaSituacao: 'Are there any caveats in the situation?',
		habilitaCamp: 'When you enable maintenance in the CAMP, it is necessary to give the first load in the inspections and tasks already done, doing this, it is necessary to put the start date of this load, from this day, if you have log books filled and / or update loads, the system will update the times of the aircraft and components that are connected to it.',
		habilitacao: 'Habilitation',
		habilitacaoExcluido: 'Habilitation successfully removed',
		habilitado: 'able',
		habilitar: 'Enable',
		habilitarCargasEmTempos: 'Enable tempo loading',
		habilitarContrato: 'Enable contract',
		habilitarContratoConfirmacao: 'Do you really want to enable this contract?',
		habilitarInspecao: 'Enable Inspection',
		haviamCargasPerigosas: 'Were there dangerous cargoes?',
		helicopteros: 'Helicopters',
		historico: 'Historic',
		historicoAcesso: 'Access History',
		historicoAtualizacoesDocumento: 'Documento update history',
		historicoDoEmpenho: 'Commitment History',
		historicoSistema: 'System History',
		historicoVoo: 'Change Log',
		homeHora: 'Man/Hour',
		hora: 'Time',
		horaFinal: 'Final Hour.',
		horaInicial: 'Initial Hour.',
		horario: 'Schedules',
		horarioApresentacaoTripulacao: 'Crew Presentation Schedule',
		horarioMaisComum: 'Most common time',
		horarioPrevisto: 'Estimated time',
		horariosMaisComuns: 'Most common times',
		horas: 'Hours',
		horasAcionamentoCorte: 'Cutting Activation Hours',
		horasCelulaProximaInspecao: 'Hours Cell Next Inspection',
		horasDeCelulaParaAProxima: 'Airframe hours planned for the next inspection',
		horasDeUtilizacao: 'Hours of Use',
		horasDeVooApoio: 'Flight Hours in Support',
		horasDecolagemPouso: 'Takeoff to Landing Hours',
		horasDisponiveis: 'Hours Available',
		horasDisponivel: 'Remaining',
		horasECiclosDoMes: 'HOURS AND CYCLES OF THE MONTH',
		horasMotor: 'Engine Hours',
		horasMotorInformativo: 'Referring to the engine hours computed at the time of filling out the Logbook. The amount will be informed only after completing the form',
		horasOvnAntesDb: 'NVG hours before completing the first logbook',
		horasPilotoComandoInstrucao: 'Pilot-in-Command hours also include hours as Pilot-in-training',
		horasTotais: 'Total Hours',
		horasTotaisAcionamentoCorte: 'Total Hours Driven to Cut',
		horasTotaisDecolagemPouso: 'Total Hours Takeoff to Landing',
		horasUsoDecimal: 'Hours of Use (Decimal)',
		horasVoadas: 'Flight Hours',
		horasVoadasAbreviacao: 'HF',
		horasVoo: 'Hours of Flight',
		horasVooTripulacao: 'Flight Hours Crew',
		horasVooUsuarioOvn: 'Flight Hours using NVG',
		horimetro: 'Hourmeter',
		horimetroCelula: 'Airframe Hourmeter',
		horimetroFinal: 'Hm. Final',
		horimetroFinalCelula: 'Hm. Final Cell',
		horimetroFinalManutencao: 'Hm. Final Maintenance',
		horimetroFinalMotor: 'Final Engine Horimeter',
		horimetroInicial: 'Hm. Initial',
		horimetroInicialCelula: 'Hm. Initial Cell',
		horimetroInicialManutencao: 'Hm. Initial Maintenance',
		horimetroInicialMotor: 'Engine Starter Horimeter',
		horimetroInicialOvn: 'NVG usage hours',
		horimetroManutencao: 'Maintenance Hourmeter',
		horimetroMotor: 'Engine Hourmeter',
		horimetroProximaInspecao: 'Next inspection hour meter',
		horimetroUltimaInspecao: 'Last inspection hour meter',
		houveAcionamentoDosOrgaos: 'Was there activation of the external components of the ',
		houveAlijamento: 'Was there an emergency or inadvertent dump of dangerous items?',
		houveCargaTransportada: 'Was there charge carried?',
		houveUmErroAoTentarAcessarOSeguinteEnderecoURL: 'There was an error trying to access the following URL address',
		houveUmErroAoTentarSalvar: 'There was an error while trying to save',
		icone: 'Icon',
		id: 'Id',
		idadeAparente: 'Apparent Age',
		identificacaoVoo: 'Flight Identification',
		ifrSimulado: 'Simulated IFR',
		imagem: 'Image',
		imagensCadastradas: 'Registered Images',
		importar: 'Import',
		importarLayer: 'Import Layer',
		imprimir: 'Print',
		imprimirEtiqueta: 'Print label',
		imprimirPDF: 'Print PDF',
		imprimirRequisicao: 'Print requisition',
		inativo: 'Inactive',
		incisoss: 'INCISES XIII A XVII',
		incluir: 'Include',
		incluirLer: 'Include + to read',
		inclusao: 'Inclusion',
		indeterminada: 'Undetermined',
		indicador: 'Indicator',
		indicadorAno: 'Annual Indicator',
		indicadorMes: 'Monthly Indicator',
		indiceDocumento: 'Index by document type',
		indiceNomeDocumento: 'Index of documents',
		indicePorDocumento: 'Index by name',
		indisponibilidadeAeronave: 'Aircraft unavailability',
		indisponibilidadeEfetivo: 'Indispensability of effect',
		indisponibilizarAeronave: 'Make Aircraft Unavailable',
		indisponivel: 'Not Available',
		info: 'Information',
		infoHorasOvn: 'Fill in this field with the total hours of flight you have already performed using NVG. After completing this, the system will automatically add this initial value to the flight hours in the logbook',
		infoOrdemDeMissao: 'Mission Order Information',
		informacaoDiarioMecanico: 'In order to load the tracks you can use the filters. Long periods of time or too many aircrafts should impact the functionality of the process.',
		informacaoDoPonto: 'Point Information',
		informacaovoo: 'Flight Information',
		informacoesAdicionais: 'Additional Information',
		informacoesAdicionaisProduto: 'Addition Product Information',
		informacoesIniciais: 'Initial Information',
		inicial: 'Initial',
		inicio: 'Start',
		inicioCargaOpcao: 'When you enable maintenance in the followair, it is necessary to give the first load in the inspections and tasks already done, doing this, it is necessary to put the start date of this load, from this day, if you have log books filled and / or update loads, the system will update the times of the aircraft and components that are connected to it.',
		inicioDaOrdem: 'Order Beginning',
		inicioDoMesReferencia: 'Start of the Reference Month',
		inicioOrdem: 'Order Beginning',
		inicioSBH: 'Start SBH',
		inpecoesAssinadas: 'Signed Inspection(s).',
		inscricao: 'Inscription',
		inseridoManualmentePor: 'Manually inserted by',
		inseridoPor: 'Inserted by:',
		insiraCaso: 'or enter one if you do not have',
		inspecao: 'Inspection',
		inspecaoAdicionadaComSucesso: 'Inspection added successfully',
		inspecaoAtiva: 'Active Inspection',
		inspecaoDesativada: 'Inspection Disabled',
		inspecaoEmMeses: 'Next inspection in Months',
		inspecaoExcluidaComSucesso: 'Inspection successfully deleted',
		inspecaoListadas: 'The inspections listed do not contain components linked to the same',
		inspecaoVinculada: 'linked inspection',
		inspecoes: 'Inspections',
		inspecoesMandatorias: 'Mandatory Inspections',
		inspecoesNaoMandatorias: 'NON-Mandatory Inspections',
		inspetor: 'Inspector',
		inspetorResponsavel: 'Responsible Inspector',
		instalacao: 'Installation',
		instrucao: 'Instruction',
		instrumentos: 'Tools',
		instrutor: 'Instructor',
		instrutorVoo: 'flight instructor',
		instruçãoDemissao: 'MISSION INSTRUCTION',
		interacaoSalva: 'Interaction saved',
		intercambialidade: 'Interchangeability',
		intercambiaveisAdicionadas: 'Interchangeable added',
		intervalo: 'Interval',
		intervaloServico: 'Service Interval',
		inverter: 'Reverse',
		irParaA: 'go to',
		irParaO: 'GO TO',
		irParaOrdemDeMissao: 'Go to the Work Order',
		irParaOrdemServico: 'Go to the Work order',
		item: 'Item',
		itemAtualizado: 'Updated item',
		itemJaAdicionado: 'Item already added',
		itens: 'Itens',
		itensComOEstadoDefeituosoOuDescarteNaoEstaoDisponiveisParaEntrega: 'DEFECTIVE or DISCARDED items are not available for delivery',
		itensIntercambiaveis: 'Interchangeable items',
		itensParaAeronave: 'Aircraft Items',
		jaExiste: 'Already exists.',
		jantar: 'Dining',
		jivochat: 'Jivochat',
		jornadaDeTrabalho: 'Work Day',
		jornadaMensal: 'Monthly Shift',
		jornadaTrabalho: 'Workday',
		jornadaTrabalhoCumprida: 'Workday Accomplished',
		juntadoTrechos: 'Joining Sections',
		justificativa: 'Justification',
		justificativaInspecao: 'this inspection need a justification',
		kitComissaria: 'Commissioner Kit',
		kmAtual: 'Current Km',
		kmVoado: 'Km Flown',
		largura: 'Width',
		lat: 'lat',
		latInicio: 'Lat Start',
		latitude: 'Latitude',
		latitudeFinal: 'Final latitude',
		latitudeInicial: 'Starting latitude',
		lavagemCompressor: 'Compressor Washing',
		layer: 'Layer',
		layerAtualizadoSucesso: 'Layer updated successfully!',
		layerCadastradoSucesso: 'Layer successfully registered!',
		layerExcluidoSucesso: 'Layer successfully deleted!',
		legislacao: 'Legislation',
		lei: 'Law',
		leiAeronaura: 'Aeronaut Law',
		leiaAOrdem: 'Read your order and at the end click on "UPDATE ORDER".',
		leiaQRCode: 'Read the QR Code through Followair on your phone.',
		leiaSuaSolicitacao: 'Read your request and at the end click on "SUBMIT REQUEST".',
		leitores: 'Readers',
		leituraConfirmada: 'Read Confirmed',
		leituraExcluida: 'Required read deleted.',
		leituraObrigatoria: 'Required read',
		leituraObrigatoriaUsuario: 'Mandatory reading for the actual user',
		ler: 'to Read',
		letra: 'Letter',
		liberadoParaConhecimentoGeral: 'Released for General knowledge',
		libras: 'Pounds',
		licenca: 'License',
		licencaExcluida: 'License deleted',
		licencasHabilitacoesRegistros: 'Licenses, Qualifications and Registrations',
		lido: 'Read',
		lidoPor: 'Read by',
		limite: 'Limit',
		limiteReferencia: 'Reference Limit',
		limitesContratuais: 'Contract Limits',
		limpaTudas: 'Clear All',
		limpar: 'Clean',
		limparFiltro: 'Clear Filter',
		linhaContrato: 'Contract Line',
		linhaDoContrato: 'Contract Line',
		linkAPP: 'Link App',
		linkBD: 'Database Link',
		linkTrello: 'Link to Trello',
		linkWS: 'Link WS',
		links: 'Links',
		liquida: 'Liquid',
		lista: 'list',
		listaContratosNaoOcultos: 'This list refers to non-hidden contracts',
		listaContratosOcultos: 'This list refers to hidden contracts',
		listaDePerfis: 'Profile List',
		listaNFS: 'Invoice List',
		listarNovosUsuarios: 'List New Users',
		litros: 'Liters',
		lng: 'lng',
		local: 'Local',
		localDeNascimento: 'Place of Birth',
		localisacaoPorao: 'Hold location',
		localizacao: 'Location',
		logAcessos: 'Access Log',
		logProcessamento: 'Registry Log',
		login: 'Login',
		loginAs: 'Login at',
		loginsHoje: 'Logins for today',
		logitudeFinal: 'Final Logitude',
		logitudeInicial: 'Initial Logitude',
		logo: 'Customer logo',
		logradouro: 'Address',
		longInicio: 'Long Start',
		longitude: 'Longitude',
		lotacao: 'Sector',
		lote: 'Batch',
		maintenanceStatus: 'Maintenance Status',
		maiorValor: 'Greater than the value.',
		maisDeumDespacho: 'We found more than one dispatch for this aircraft, select which dispatch that flight refers to.',
		maisDeumItem: 'more than one item',
		maisDias: 'more days',
		maisInformacoes: 'More information',
		malha: 'Mesh',
		malhaAnual: 'Annual mesh',
		malhaSemanal: 'Weekly mesh',
		malhaVoo: 'Flight Mesh',
		malhas: 'Meshes',
		manuais: 'Manuals',
		manual: 'Manual',
		manualOnline: 'Online Manual',
		manutencao: 'Maintenance',
		manutencaoAeronave: 'Aircraft Maintenance',
		manutencaoAtrasada: 'Delayed Maintenance',
		manutencaoCamp: 'CAMP Maintenance',
		manutencaoCiencia: 'Model of maintenance in Science',
		manutencaoDeuParecer: 'Has the opinion of the maintenance',
		manutencaoNaoDeuParecer: 'Maintenance did not give an opinion',
		manutencoes: 'Maintenances',
		mapa: 'Map',
		marcaDagua: 'Watermark',
		marcaOuModelo: 'Brand / Model',
		marcadores: 'Markers',
		marcarTodos: 'Select all',
		margem: 'margin',
		margemTelaLogin: 'Login screen margin in pixels',
		marqueOsTrechosQueACargaIra: 'Select the sections that the passager is in',
		marqueOsTrechosQueOPassageiroIra: 'Select the segments that the passager will go:',
		masc: 'Male',
		materiaEncerrada: 'Matter closed by',
		matricula: 'Registration',
		matriculado: 'Registered',
		maximo: 'Maximum',
		mecanico: 'Mechanic',
		mecanicoResponsavel: 'Responsible Mechanic',
		mecanicos: 'Mechanic',
		media: 'Average',
		mediaCiclos: 'Avarage Cycles',
		mediaHorasDiario: 'Average hours flown daily',
		mediaHorasMes: 'Average hours flown monthly',
		mediaManual: 'Manual Average',
		medicao: 'Measurement',
		medico: 'Medic',
		mensagem: 'Message',
		mes: 'Month',
		mesAtual: 'Current month',
		meses: 'Months',
		mesesDias: 'Months and Days',
		mesmoDbMovimentacoes: 'These logbooks were found below for this EC number and this aircraft. Select the logbook referring to this movement',
		mesmoMovimentacoesDb: 'These fuel movements below were found for this EC number and this aircraft. Select the fuel movement for this logbook',
		messagemInputError: 'Invalid value!',
		meta: 'Goal',
		metaAno: 'Annual Goal',
		metaHoras: 'Goal Hours',
		metaIndicadores: 'Goal and Indicators',
		metaMes: 'Monthly Goal',
		metricas: 'Metrics',
		milhas: 'Miles',
		milhasNauticas: 'Nautical Miles',
		minutos: 'Minutes',
		missao: 'Mission',
		missaoSigilosa: 'Is mission confidential?',
		modalErroElementoJaInserido: 'Element has already been inserted',
		modelo: 'Model',
		modeloAtualizado: 'Model Updated',
		modeloDoMapa: 'Map template',
		modeloInserido: 'Model Added',
		modelos: 'Models',
		modelosAtualizados: 'Updated Templates',
		modulo: 'Choose the module you want to access',
		moduloManutencao: 'Maintenance Module',
		modulos: 'Modules',
		moeda: 'Currency',
		monitora: 'Monitor',
		monitorada: 'Tracked',
		monitoramento: 'Monitoring',
		monitoramento1: 'Monitoring',
		mostrarDetalhes: 'Show details',
		mostrarItens: 'Show items',
		motivacao: 'Motivation',
		motivo: 'Reason',
		motivoApareceraDiario: 'This reason will appear in the signature of this logbook',
		motivoDaEdicao: 'Reason for editing',
		motivoReassinatura: 'reason for resignation',
		motor: 'Engine',
		motorAdicionado: 'Powerplant Added',
		motorAtualizado: 'Powerplant Updated',
		motorEHorario: 'Engine and Schedule',
		motores: 'Engines',
		movimentacao: 'Handling',
		movimentacaoCombustivel: 'Fuel Handling',
		movimentacaoCombustivelEntreUnidades: 'Fuel Movement between Units',
		movimentacaoCombustivelEntreUnidadesSucesso: 'Fuel Movement between Units Saved with Success',
		movimentacaoDeCombustivel: 'Fuel Handling',
		movimentacaoDeCombustivelExcluidaComSucesso: 'Fuel move deleted successfully',
		msgPagamentoMaiorPagamento: 'You are adding a larger amount than the purchase.',
		mudancaFuncao: 'Change of Function',
		mudarMoeda: 'Change the currency',
		multicamadasMapa: 'Multilayer on map',
		municipio: 'City',
		nOrdem: 'Order Number',
		nSolicitacao: 'Request number',
		nacionalidade: 'Nationality',
		nao: 'No',
		naoAprovado: 'Not approved',
		naoAssinados: 'Unsigned',
		naoCalculado: 'Uncalculated',
		naoControlado: 'Not Controlled',
		naoDefinido: 'Undefined',
		naoDocumento: 'There is not document avaible in attachment',
		naoEPossivelColocarUmValorQueEstaAbaixoDoTotalDeProdutosServicos: 'It is not possible to place a value that is below the total of products/services',
		naoEPossivelEscolherUmaQuantidadeMaiorQueADisponivelNoEstoque: 'It is not possible to choose a quantity greater than that available in stock',
		naoEPossivelRemoverUmEmpenhoQueHaProdutosServicosVinculados: 'It is not possible to remove an engagement that there are linked products/services',
		naoEncontramosSuaAero: 'We did not find this aircraft within the mission order, if you wanted to import the aircraft data from the mission order, simply click on the model below.',
		naoExecutado: 'Not executed',
		naoExisteDespachoAvulso: 'No single flight schedule found',
		naoExisteFatoresContribuintesParaOObjetoEscolhido: 'There are no contributing factors for the chosen object',
		naoExisteNenhumParecerParaEsteRelatorio: 'There is no opinion for this report',
		naoFoiPossivelAlterarSenha: 'Could not change password.',
		naoFoiPossivelAssinar: 'Could not subscribe',
		naoFoiPossivelAssinarOS: 'Unable to sign Service Order',
		naoFoiPossivelCadastrarUsuario: 'Unable to register User',
		naoFoiPossivelCancelar: 'Unable to cancel',
		naoFoiPossivelEncontrarDados: 'No data was found by this login.',
		naoFoiPossivelEnviarSuprimentos: 'Unable to ship supplies',
		naoFoiPossivelExcluir: 'Unable to delete',
		naoFoiPossivelGerarRelatorio: 'Report could not be generated',
		naoHaAeronaves: 'There are no aircraft',
		naoHaCarga: 'No charge',
		naoHaDiariosDeBordo: 'There are no open log books, unsigned log books',
		naoHaDiscrepancia: 'There are no discrepancies',
		naoHaEmpregoAeronave: 'There is no aircraft employment',
		naoHaNenhumVoo: 'THERE ARE NO SPECIAL FLIGHTS REGISTERED',
		naoHaNenhumaTarefaCadastrada: 'There is no task registered',
		naoHaRoteiro: 'There is no script',
		naoInformado: 'Uninformed',
		naoLido: 'Not read',
		naoNecessarioImprimirRelprev: 'No need to print RELPREV',
		naoPossivelExcluirUnidadeMedidaSuprimentosLigados: 'You cannot delete a unit of measure with supplies attached to it',
		naoPossui: 'DOES NOT',
		naoPossuiEntregas: 'No deliveries',
		naoSaiaDessaTela: 'Do not leave this screen, this will interrupt the process.',
		naoSatisfeito: 'NOT SATISFIED',
		naoSelecionouData: 'You did not select a date.',
		naoTemManutencao: 'There is no maintenance',
		naoTemParecerManutencao: 'Do not have the opinion of maintenance',
		naoTemParecerOperacoes: 'Do not have the opinion of the operations',
		naoTenhoUmAerodromoDefinido: 'I do not have a definite aerodrome.',
		nascer: 'Sunrise',
		naturalidade: 'naturalness',
		natureza: 'Nature',
		naturezaDoVoo: 'Nature of Flight',
		naturezas: 'Natures',
		navegacao: 'Navigation',
		necessarioAdicionarPeloMenosUmItemAoPN: 'Necessary to add at least one item to the PN',
		necessarioPeloMenosUmaInspecao: 'At least one inspection required to update',
		negada: 'Denied',
		negar: 'Deny',
		negativo: 'Negative',
		nenhum: 'No',
		nenhumAlertaEncontrado: 'NO ALERTS FOUND',
		nenhumArquivo: 'No files attached',
		nenhumArquivoAnexado: 'No files attached',
		nenhumDadoEncontrado: 'No data found for this date.',
		nenhumDespacho: 'We did not find any dispatch for this aircraft, select one from the list or enter an dispatch.',
		nenhumDespachoParaEssesDias: 'No dispatch for those days',
		nenhumDiarioDeBordoEncontrado: 'NO LOGBOARD FOUND IN THIS PERIOD',
		nenhumDiarioDisponivelParaAssinatura: 'No logbook available for subscription.',
		nenhumHistoricoEncontrado: 'No historic found.',
		nenhumItemEncontrado: 'No Itens was found',
		nenhumMotorAcionado: 'No powered engine',
		nenhumProdutoFoiAdicionado: 'No products were added',
		nenhumRegistroEncontrado: 'No record was found',
		nenhumResultadoFoiEncontrado: 'No results found',
		nenhumTrecho: 'No stretch.',
		nenhumTrechoAdicionado: 'No stretch was added.',
		nenhumValorRegistrado: 'No value recorded',
		nenhumVooEncontrado: 'No flights found.',
		nenhumaAcao: 'No action',
		nenhumaAcaoFoiTomadaDiscrepancia: 'No action was taken for this discrepancy.',
		nenhumaAeronaveAdicionada: 'No aircraft added',
		nenhumaAlteracao: 'No changes made to the diary will be saved, for this you have to click on edit log',
		nenhumaConversaEncontrada: 'No conversations found.',
		nenhumaDiscrepanciaAberta: 'No open discrepancy.',
		nenhumaDiscrepanciaEncontrada: 'No discrepancies found',
		nenhumaDisponibilidadeEncontrada: 'No avaibility was found.',
		nenhumaDocumentacaoAdicionada: 'No Documentation Added',
		nenhumaEscalaEncontrada: 'No scale was found',
		nenhumaImagemCadastrada: 'No Image Registered',
		nenhumaInformacaoEncontrada: 'No Information Found',
		nenhumaInspecaoEncontrada: 'No inspetions were found.',
		nenhumaMalha: 'There is no registered mesh',
		nenhumaNotificacao: 'You have no notification',
		nenhumaNotificacaoEncontrada: 'No notifications found',
		nenhumaObservacao: 'No notes added',
		nenhumaOrdemFoiEncontrada: 'No requests found.',
		nenhumaOrdemParaEssesDias: 'No Order for these days',
		nenhumaPosicaoEncontrada: 'No position found',
		nenhumaRessalvaAdicionada: 'No Added Caveat',
		nenhumaSolicitacaoParaEssesDias: 'No Request for these days',
		nenhumaTripulacaoAdicionada: 'No crew members added',
		nice: 'GOOD',
		nivel: 'Level',
		nivelDeAprendizagem: 'Level of Learning',
		noMes: 'Month',
		nome: 'Name',
		nomeAdicionado: 'Added name',
		nomeAlternativo: 'Alternative Name',
		nomeCompleto: 'Full Name',
		nomeContato: 'Contact Name',
		nomeDaCategoria: 'Category Name',
		nomeDaUnidade: 'Unit Name',
		nomeDoVoo: 'Flight Name',
		nomeDocumentoJaExistente: 'This document name already exists',
		nomeESobrenomealuno: 'NAME AND LAST NAME',
		nomeESobrenomeinstrutor: 'NAME AND SURNAME OF THE INSTRUCTOR',
		nomeModelo: 'Model',
		nomePasta: 'Folder Name',
		nomePrincipal: 'First Name ',
		nomeTipoDocumentoJaExistente: 'This document type name already exists',
		nomeTratamento: 'Name of treatment',
		nomeclaturaComumMercosul: 'Mercosur Common Nomenclature',
		nomeclaturaOleoLubrificante: 'Inform the nomenclatures that will be displayed in the Logbooks if there is lubricating oil control',
		normas: 'Standards',
		nos: 'knots',
		nota: 'Note',
		notaCadastradaSistema: 'Invoice Registered in the System',
		notaFiscal: 'Invoice',
		notasAtualizacao: 'Update Notes',
		notasDaVersao: 'Release Notes',
		notificaTripulacao: 'Notify crew ',
		notificacao: 'NOTIFICATIONS',
		notificacaoAtualizada: 'Updated notification',
		notificacaoEncontrada: 'notification (s) found',
		notificacoesEnviadas: 'Sent Notifications',
		notificadoComSucesso: 'Successfully notified',
		notificar: 'Notify',
		noturno: 'Nightly',
		nova: 'New',
		novaAcao: 'New Action',
		novaAssinatura: 'New Signature',
		novaCategoria: 'New Category',
		novaComunicacao: 'New Communication',
		novaDisciplina: 'New Discipline',
		novaDiscrepancia: 'New Discrepancy',
		novaDocumentacao: 'New Documentation',
		novaHabilitacao: 'New license',
		novaInteracao: 'New Interaction ',
		novaMalha: 'New mesh',
		novaNota: 'New Invoice',
		novaObservacao: 'New note',
		novaPrestacao: 'NEW SERVICE PROVISION',
		novaSenha: 'New password',
		novo: 'NEW',
		novoAcionamento: 'New Activation',
		novoCapitulo: 'New Chapter',
		novoContato: 'New Contact',
		novoDespacho: 'New Dispatch',
		novoFornecedor: 'New Supplier',
		novoKit: 'New Kit',
		novoLayer: 'New Layer',
		novoMotor: 'New Powerplant',
		novoParametro: 'New Parameters',
		novoPonto: 'New Point',
		novoProcedimento: 'New Procedure',
		novoRelatorio: 'New Report',
		novoSimplificado: 'New Simplified',
		novoTicket: 'New Ticket',
		novoTrecho: 'New leg',
		novoUsuario: 'New user',
		numAtividade: 'No. activity',
		numChamada: 'No. Call',
		numMotores: 'Engine\'s Number',
		numReds: 'No. REDS',
		numSiape: 'SIAPE Number',
		numberMotor: 'Nº Engine Series',
		numero: 'Number',
		numeroCarne: 'Number of booklet',
		numeroCe: 'CE Number',
		numeroCodigo: 'Code Number',
		numeroDB: 'LB Number',
		numeroDaCE: 'CE Number',
		numeroDaFatura: 'Bill number',
		numeroDaNota: 'Invoice Number',
		numeroDaOrdem: 'Order\'s number',
		numeroDaProgramacao: 'Schedule number',
		numeroDeCE: 'EC number',
		numeroDeVoo: 'Flight number',
		numeroDiario: 'Daily Number',
		numeroDoCe: 'Number of delivery receipt',
		numeroDoContrato: 'Contract\'s number',
		numeroDoDespacho: 'Dispatch',
		numeroDoDiarioDeBordo: 'Logbook Number',
		numeroDoEmpenho: 'Effort number',
		numeroDoPedido: 'Request Number',
		numeroIdentificacaoEmpregado: 'Employer Identification Number',
		numeroLei: 'Law Number',
		numeroLicenca: 'Number of License',
		numeroOrdemServico: 'Service Order Number',
		numeroPatrimonio: 'Equity Number',
		numeroPeca: 'Part Number',
		numeroPrevencao: 'Number of Prevention',
		numeroSolicitacao: 'Number of request',
		numeroTarefa: 'Task Number',
		numeroTicket: 'Ticket Number: ',
		oCampoDePassaporteEObrigatorioParaUmEstrangeiro: 'The passport field is mandatory for a foreigner',
		oEventoFoiAtualizadoComSucesso: 'The event has been updated successfully',
		oEventoFoiCadastradoComSucesso: 'The event was registered successfully',
		oHorimetroDeveSerMenorQueOAtual: 'The hour meter must be smaller than the current',
		oKitDeveConterUmItem: 'The kit must contain at least 01 item',
		oPrimeiroAssina: 'The crew member inserted in the first box will be responsible for signing the Logbook',
		oQueEstaAcontecendo: 'What is happening? ',
		oRelatorioFoiAtualizadoComSucesso: 'The report was updated successfully',
		oRelatorioFoiSalvoComSucesso: 'The report was successfully saved',
		oResultadoPodeDemorarUmPouco: 'the result may take a while.',
		oTipoDeSolicitacaoFoiAtualizadoComSucesso: 'The request type was successfully updated',
		oTipoDeSolicitacaoFoiExcluidoComSucesso: 'The request type was successfully deleted',
		oTipoDeSolicitacaoFoiSalvoComSucesso: 'The request type was successfully saved',
		oTrechoEstaAberto: 'Section dated <strong>{{INICIO}}</strong>, is open and needs to be completed.',
		oTrechodeInicioTexto: 'The start section <strong>{{TRECHO}}</strong>, on <strong>{{INICIO}}</strong>, is open and needs to be completed.',
		oUsuarioPodeAlterarSuasConfigs: 'Can you edit your settings?',
		objetivosAlcancados: 'Objective Achieved',
		objetivosMissaoAlcancados: 'Have mission objectives been achieved?',
		objeto: 'Object',
		obrig: 'Required',
		obrigInstrutorVoo: 'Required for flight instructor',
		obrigPilotoComando: 'Mandatory for pilot in command',
		obrigacao: 'Required',
		obrigatorio: 'Fields with * are obligatory',
		obs: 'Note',
		observacao: 'Note',
		observacoes: 'Comments',
		observacoesImportante: 'Important notes',
		ocorrencias: 'Occurrences',
		ocorreuErroTenteNovamente: 'An error has occurred, please try again',
		ocultar: 'Hide',
		ocultarContrato: 'Hide Contract',
		ocultarContratoConfirmacao: 'Do you really want to hide this contract?',
		ocultarContratoNaoVigente: 'Hide expired contracts',
		oficina: 'workshop',
		oficio: 'Craft number',
		okParaUso: 'Ok for use?',
		ola: 'Hello',
		oleoLubrificante: 'Lubricant',
		ondeNoEstoque: 'Where in stock',
		opcoes: 'Options',
		operacao: 'Operation',
		operacional: 'Operational',
		operacoes: 'Operations',
		operacoesDeuParecer: 'Has the opinion of the operations',
		operacoesNaoDeuParecer: 'The operations did not give the opinion',
		operador: 'Operator',
		operadorAerotatico: 'Air Operator',
		operadorIndefido: 'The operator has not been defined',
		ordemCancelada: 'Canceled order',
		ordemDeMissao: 'Order of Mission',
		ordemDeMissaoSalva: 'Order of Mission Saves',
		ordemDeServico: 'Work orders',
		ordemDeServicoConcluida: 'Order of Service Completed',
		ordemDeServicoSalvaComSucesso: 'Service Order Saves Successfully',
		ordemEncerrada: 'Order closed',
		ordemMissao: 'Mission Order',
		ordemMissaoEncerrada: 'Mission Order closed',
		ordemMissaoPrevencaoQualificada: 'Order of Mission of Qualified Prevention',
		ordemMissaoReaberta: 'Reopened Mission Order',
		ordemMissaoRetornoExecucao: "Mission Order returned to 'Running'",
		ordemMissaoRetornoExecucaoErro: "Unable to return Mission Order to 'Running'",
		ordemServico: 'Work Order',
		ordemServicoCancelada: 'Service order canceled',
		ordemServicoManutencao: 'Maintenance Service Order',
		ordensDeMissao: 'Mission Orders',
		ordensGeradas: 'Orders generated',
		organizacao: 'Organization',
		orgao: 'Agency',
		orgaoApioadoSalvo: 'Organized supported Added',
		orgaoApoiado: 'Agency Supported',
		orgaoApoiadoAtualizado: 'Organized supported updated',
		orgaoApoiadoAtualizadoComSucesso: 'Agency Supported successfully updated.',
		orgaoApoiadoUnidades: 'Agency Supported - Units',
		orgaoOperador: 'Organ Operator',
		orgaoProprietario: 'Owner\'s Body',
		orgaoSolicitante: 'Requesting Agency',
		orgaoUtilizam: 'Organs using the aircraft',
		orgaos: 'Agencies',
		orgaosApoiados: 'Supported Organs',
		orgaosApoiadosDesativados: 'Deactivated supported organ',
		origem: 'Source',
		origemDoVoo: 'Flight origin',
		origemSistema: 'System source document',
		osArquivosNãoPodemSerMaiorQue: 'The file(s) cannot be larger than',
		osDeSaida: 'Outgoing WO',
		osTrechosPrecisamSerSeqquencial: 'The selected passages need to be sequential.',
		ou: 'Or',
		outras: 'Others',
		outrasClassificacao: 'Others',
		outros: 'Others',
		pacote: 'Package',
		padrao: 'Standard',
		padraoProcedimento: 'Standard Operating',
		pagamento: 'PAYMENT',
		pagamentoFeitoSucesso: 'Payment successfully added',
		pagamentoNaoEfetuado: 'No Payment Done',
		pais: 'Country',
		pancreas: 'Pancreas',
		para: 'for',
		paraAddObrigatorio: 'To \'New\' this field is required.',
		paraAdicionarEmpenhos: 'To add Efforts',
		paraAdicionarTarefasVocePrecisaTerPeloMenosUmaInspecao: 'To add tasks you need to have at least one inspection',
		paraRemoverEsteGrupoVocePrecisaRemoverTodasTarefasLigadaAEle: 'To remove this group you need to remove all tasks connected to it',
		paraTodosOsArquivos: 'for all files',
		parametro: 'Parameter',
		parametrosAeronave: 'Aircraft Parameters',
		parametrosLegais: 'Legal Parameters',
		parametrosMidia: 'Parameters and averages',
		parcela: 'Portion',
		parcelas: 'Plots',
		parciais: 'Partial',
		parcial: 'Partial',
		parcialmentePago: 'Partly Paid',
		parecer: 'Opinion',
		parecerAdicionadoComSucesso: 'Opinion added successfully',
		pareceres: 'Opinions',
		partida: 'departure',
		partidas: 'Departures',
		passageiro: 'Passenger',
		passageiroAtualizadoComSucesso: 'Passenger successfully updated',
		passageiroExcluidoComSucesso: 'Passenger successfully deleted',
		passageiroSalvoComSucesso: 'Passenger successfully saved',
		passageiros: 'Passengers',
		passageirosDaAeronave: 'Aircraft Passengers',
		passaporte: 'Passport',
		passouTolerancia: 'Passed from tolerance',
		patrimonial: 'Equity',
		patrimonio: 'Heritage',
		pedidoCanceladoComSucesso: 'Order canceled successfully',
		pedirPecas: 'Order Parts',
		peloMenosUmContato: 'You need to add at least one contact',
		peloMenosUmTelefone: 'You need to add at least one phone number',
		peloUsuario: 'by the user',
		pendentePagamento: 'Pending Payment',
		percentualRestante: 'Remaining percentage',
		percursoASerEfetuado: 'Training to be carried out',
		perfil: 'Profile',
		perfilDoUsuario: 'View Profile',
		perfilTipo: 'Profile Type',
		perfilTripulacao: 'Profile Crew',
		perfis: 'Profiles',
		perguntasERespostas: 'Questions and answers',
		perigosa: 'Dangerous',
		periodicidade: 'Interval',
		periodo: 'Period',
		periodoDeTesteAcabou: 'The test period is over',
		permissaoExcluida: 'Permission deleted',
		permissaoNegada: 'Permission declined',
		permiteAlterarOContrato: 'Allows you to change the contract',
		permiteMovimentarOContrato: 'Allows you to move the contract',
		pernoite: 'Overnight stay',
		peso: 'Weight',
		pesoAprox: 'Approximate weight (Kg)',
		pesoPassageiro: 'Passenger Weight',
		pesoTotal: 'Total baggage weight',
		pesquisar: 'search',
		pesquisarPor: 'Search for: ',
		pessoalEnvolvido: 'Staff involved',
		pessoasDetidas: 'Detained Persons',
		pessoasSalvas: 'People Saved',
		piloto: 'Pilot',
		pilotoComandante: 'Commanding pilot',
		pilotoComando: 'Pilot in Command',
		pilotoECopiloto: 'Pilot and Co-pilot',
		pilotoEmInstrucao: 'Pillot in Instruction',
		pilotoInstrucao: 'Pilot in Instruction',
		pilotoResponsavel: 'Responsible Pilot',
		pilotos: 'Pilot',
		piltoEmComando: 'Pillot in command',
		placa: 'License plate',
		planejada: 'Planned',
		plano: 'Plan',
		planoDeFundo: 'Wallpaper Home Screen',
		planoDeFundoAtual: 'Current Background',
		planoDeRegistro: 'AIRPLANE',
		planoPlem: 'Airport Emergency Plan (AEP)',
		planoPre: 'Company Emergency Response Plan (CERP)',
		planta: 'Plant',
		pn: 'PN',
		podeSerAlocado: 'Allocation Permission',
		ponto: 'Point',
		pontos: 'Markers',
		pontosInteresse: 'Points of Interest',
		pontualOuCondicao: 'Punctual or On Condition',
		por: 'Sunset',
		por1: 'by',
		porAero: 'By',
		porArtigo: 'By',
		porHoraVoada: 'By Flying Hour',
		porQuestoesAlterarSenha: 'For security reasons it is necessary for you to change your password.',
		porQuestoesDeSeguranca: 'for security reasons it is necessary that you change your Digital Signature',
		porcentagem: 'Percentage',
		porcentagemConsumidaDoContrato: 'Contract consumed percentage',
		porcentagemConsumidaDoEmpenho: 'Percentage of effort consumed',
		posGraduacao: 'Post-graduation',
		posicao: 'Position',
		posicaoVoo: 'Flight Positions',
		posicoes: 'Positions',
		positivo: 'Positive',
		possui: 'HAS',
		pouso: 'Landing',
		pousoPrevisto: 'Planned Landing',
		pousos: 'Landings',
		pratica: 'PRACTICE',
		prazo: 'Deadline',
		prazoParaExecucao: 'Deadline for execution',
		precoMedio: 'Average Price',
		predefinicoes: 'Templates',
		preechaTodasAsInformacoesNecessarias: 'Fill in all necessary information',
		preenchaOsDadosDoSolicitante: 'Fill in the details of the requesting authority.',
		preenchaPeloMenosUmCampo: 'Please fill at least one field',
		preencher: 'Write',
		preenchimentoConcluido: 'Completed',
		preenchimentoMotorHorario: 'The filling of the 4 fields of Engine and Time must be done in local time.',
		preenchimentoPeriodo: 'Pay attention to filling in the Day, Night, Real IFR, Simulated IFR and VFR fields.',
		prefiroNaoDeclarar: 'Not Declare',
		prefixoAeronave: 'Aircraft Tail Number',
		prefixoOuIdentificacao: 'Prefix/Identification',
		prefixoOuIdentificacaoDoVeiculo: 'Prefix / Vehicle Identification',
		pressioneCtrl: 'Press Ctrl',
		prevencao: 'Deterrent',
		prevencaoDespacho: 'Prevention',
		prevencaoQualificada: 'Qualified Prevention',
		prevencaoSalva: 'Prevention Saves',
		preventiva: 'Preventive',
		previewOrdemMissao: 'Mission order preview',
		previsao: 'Forecast',
		previsaoDeData: 'Date Forecast',
		previsaoDisponibilidadeDbEletronico: 'Electronic DB Availability Forecast',
		primeiroPilotoComando: '1st Pilot in Command',
		prioridade: 'Priority',
		privilegio: 'Privilege',
		privilegiosParaVer: 'privilege to see',
		proa: 'Bow',
		procedimento: 'Procedure',
		processaVoos: 'Processes Flights',
		processandoManutencao: 'Processing Maintenance (this may take a while)',
		processandoManutencaoVisao: 'Processing Maintenance',
		processarAuditoria: 'Process Audit',
		processo: 'Process',
		processoEmAndamento: 'Ongoing process of a mission or dispatch order.',
		produto: 'Product',
		produtoExcluidoComSucesso: 'Product successfully deleted',
		produtoSalvoComSucesso: 'Product successfully saved',
		produtoServico: 'Producto/Servicio',
		produtoServicoExcluidoComSucesso: 'Producto/Servicio eliminado correctamente',
		produtoServicoSalvoComSucesso: 'El producto/servicio se ha guardado correctamente',
		produtos: 'Products',
		produtosServicos: 'Productos/Servicios',
		produtosServicosVinculados: 'Linked products/services',
		programacao: 'Programming',
		programacaoDeVoo: 'Flight Programming',
		programacaoVoo: 'Flight Schedule',
		provedorSMS: 'SMS Provider',
		proximaData: 'Next Date',
		proximaHora: 'Next Hour',
		proximaInspecao: 'Next Inspection',
		proximaInspecaoCamp: 'Next Due',
		proximo: 'Next',
		qtdDias: 'Day Quantity',
		qtdPago: 'Paid Quantity',
		qtdSolicitado: 'Requested Quantity',
		qtdeASerEntregue: 'Qty. to be Delivered',
		qtdeEmEstoque: 'Qty. in stock',
		qtdeEntregue: 'Qty. Delivered',
		qtdeRecebida: 'Qty. Received',
		qtdeSolicitado: 'Qty. Requested',
		quadrantes: 'Quadrants',
		qualAeronaveVaiSerUtilizada: 'Which aircraft will be used?',
		qualDirigenteDesseOrgao: 'Who is the leader of this body?',
		qualOMotivo: 'What is the reason?',
		qualificacaoCivil: 'Civil qualification',
		qualificada: 'Patrol',
		qualquerAeronave: 'Any aircraft',
		quandoBotaoAlerta: 'When the alert button (RED) is canceled',
		quandoPesquisarPorLongosPeriodos: 'When search for long periods',
		quantidade: 'Amount',
		quantidadeAlterada: 'Quantity Changed',
		quantidadeAtual: 'Current Quantity',
		quantidadeDeAeronavePorColuna: 'Aircraft quantity by columns',
		quantidadeDeDias: 'Number of Days',
		quantidadeDeLitros: 'Quantity of Liters',
		quantidadeDeveSerMaiorQueZero: 'Quantity must be greater than 0',
		quantidadeDeveraSerMaiorQueZero: 'Quantity must be greater than 0',
		quantidadeDisponivel: 'Available quantity',
		quantidadeEstimadaPassageiros: 'Estimated Number of Passengers',
		quantidadeHorasAcionamentoAoCorte: 'Quantity Hours (Cutting Drive)',
		quantidadeHorasDecolagemAoPouso: 'Quantity Hours (Landing Takeoff)',
		quantidadeMinima: 'Minimum Quantity',
		quantidadeMissao: 'Quantity Mission',
		quantidadeTransferir: 'Amount to Transfer',
		quantidadeTransferirMovimentacaoCombustivel: 'Amount to Transfer (l)',
		quantos: 'How many?',
		quantosItens: 'How Many Items?',
		quatro: 'Four',
		quemEOOperador: 'Who is the operator of this request?',
		quilometros: 'Kilometers',
		radial: 'Radial(degrees)',
		radio: 'Radio',
		rastreado: 'Tracked',
		rastreadoresAtivos: 'Active Trackers',
		rastreamento: 'Tracking',
		razaoLatitude: 'Latitude Ratio',
		razaoLongitude: 'Longitude ratio',
		razaoSocial: 'Company Name',
		rbacTolerancia: 'Normal operation relative to a license expired for less than 30 (thirty) days is allowed. Normal operation related to a license expired for more than 30 (thirty) days is prohibited, in any situation.',
		reabastecimento: 'Replenishment',
		reabertura: 'Reopening',
		reabrindo: 'Reopening',
		reabrir: 'OPEN',
		reabrirDespacho: 'Do you want to reopen this Office?',
		reabrirOrdem: 'Reopen Order',
		realprevTelaLogin: 'Realprev Login Screen',
		reativadoComSucesso: 'Successfully reactivated',
		reativar: 'Reactivate',
		receber: 'Receive',
		receberSuprimentos: 'Receive supplies',
		recebido: 'Received',
		recebidoPor: 'Received by',
		recomendacao: 'Recommendation',
		recomendacoes: 'Recommendations',
		refOrigem: 'Ref Origin',
		refereSeAoInicio: 'refers the beginning',
		referenciaManual: 'Manual Reference',
		referencias: 'References',
		regNo: 'RegNo',
		registro: 'Record',
		registroHFDM: 'FDM',
		registroNome: 'REGISTRATION - NAME',
		registrosPrincipaisTabelas: 'Records in Main Tables',
		regua: 'ruler',
		reguaDigital: 'Digital Ruler',
		regulamento: 'Regulation',
		regulamentoAtualizado: 'Regulation updated',
		regulamentoExcluido: 'Regulation successfully deleted',
		regulamentoSalvo: 'Regulation saved',
		regular: 'REGULAR',
		relacao: 'Ratio',
		relator: 'Reporter',
		relatorio: 'Report',
		relatorioAbastecimento: 'Supply Report',
		relatorioAbastecimentoAnual: 'Annual Supply Report',
		relatorioAeronave: 'Aircraft Report',
		relatorioAlocacao: 'Allocation report',
		relatorioAviacaoCivil: 'Civil Aviation Report',
		relatorioCIV: 'CIV Report',
		relatorioCentroCusto: 'Cost Center Report',
		relatorioDiarios: 'Daily Reports',
		relatorioEquipamentoOvn: 'NVG Reports',
		relatorioHorasDeVoo: 'Flight Hours Report',
		relatorioHorasVoadas: 'Flight Hours Report',
		relatorioIndicadorEfetividade: 'Effectiveness Indicator Report',
		relatorioMetaHorasVoadas: 'Goal Hours Flying Report',
		relatorioMovimentacaoCombustivel: 'Fuel movimentation relatory',
		relatorioOVN: 'Report NVG',
		relatorioPerfil: 'Profile Report',
		relatorioPerfilUsuario: 'Profile and user report',
		relatorioPrecoMedio: 'Average Price Report',
		relatorioPrestacaoDeContas: 'Reporting of Accounts TDCO',
		relatorioPrevencao: 'Safety Report',
		relatorioProdutividade: 'Productivity Report',
		relatorioSinteticoDeProdutividade: 'Productivity Survey',
		relevancia: 'Relevance',
		removeTrechoVoltaHorimetro: 'Remove strech and back the hourmeter',
		remover: 'Remove',
		removerAeronave: 'Remove Aircraft',
		removidoSucesso: 'Successfully removed',
		renovacao: 'Renovation',
		requisicao: 'Request',
		requisitos: 'requirements',
		responsavel: 'Responsible',
		responsavelCarga: 'Responsible for the cargo',
		responsavelExecucao: 'Responsable for the execution',
		responsavelMovimentacao: 'Responsible for handling',
		responsavelOS: 'Responsible for the service order',
		responsavelPelaAprovacao: 'Responsible for approval for return to service',
		responsavelPelaCriacaoDaOrdem: 'Responsible for the preparation of the Order of Mission',
		responsavelPelaExecucao: 'Responsable for the execution',
		responsavelPeloRetorno: 'Responsible for the Return',
		responsavelPeloVoo: 'Responsible for the flight',
		responsavelTecnico: 'technical manager',
		ressalvas: 'Reservations',
		resultados: 'Results',
		resultadosObtidos: 'Results Obtained',
		resumoDaOrdemDeMissao: 'Update Mission Order',
		resumoDaSolicitacao: 'Request Summary',
		retornarExecucao: "Return to 'Running'",
		retirada: 'Withdrawal',
		retiradoEm: 'withdrawn on',
		retrair: 'Retract',
		revalidacao: 'Revalidation',
		revisao: 'Review',
		revisaoData: 'Revision Date',
		revisar: 'Review',
		rim: 'Kidney',
		roteiro: 'Itinerary',
		rua: 'street',
		ruaSemNome: 'Unnamed street',
		saida: 'Exit',
		sair: 'Exit',
		sairTelaCheia: 'Close Full Screen',
		saldo: 'Balance',
		salvando: 'Saving',
		salvandoGerandoRastreamento: 'Saving and generating tracking',
		salvandoSolicitacaoAvulsa: 'Saving single request',
		salvar: 'Save',
		salvarAlteracoes: 'Save editions',
		salvarE: 'Save and',
		salvarImagem: 'Save Image',
		salvarNovoPadrao: 'Save new pattern',
		salvarOrdemMissao: 'Save the work order, or go back to Due List or Manuals and enter the missing inspections',
		salvarPagamento: 'SAVE',
		salvarProcessar: 'Save and Process',
		salvarTermo: 'Save Term',
		salvarTrechos: 'Save Legs',
		salvo: 'Added',
		salvoComSucesso: 'Saved successfully',
		satelite: 'Satellite',
		saudeESanitarias: 'of health and sanitary',
		se: 'If',
		seOErroPersistirPorFavorEntreEmContatoConosco: 'If the error persists, please contact us',
		secao: 'Section',
		secaoAtualizada: 'Updated section',
		secaoExpirada: 'Section expired',
		segundoComando: 'Second in command',
		segundoPilotoComando: '2st Pilot in Command',
		segurancaPublica: 'of public safety',
		segurancaRelativa: 'of security relating to acts of unlawful interference against civil aviation',
		seguro: 'Insurance',
		sejaBemVindo: 'Seja bem-vindo ao',
		selecionadoOrgaos: 'Selected Organs',
		selecionarDespacho: 'Select Dispatch',
		selecionarItens: 'Select items',
		selecionarMalha: 'select mesh',
		selecionarOpcaoAcima: 'You have to select an option above.',
		selecionarSemana: 'Select Week',
		selecionarUmDespacho: 'Select an Dispatch',
		selecionarUmDiario: 'Select the logbook below.',
		selecione: 'Select',
		selecioneAPrevencaoQualificadaAbaixo: 'Select a qualified prevention below',
		selecioneAbaixoALista: 'select on the list below the effort that you want to add to that invoice',
		selecioneAeronave: 'Select an Aircraft',
		selecioneAoMenosUmAcesso: 'Select at least one access to the document type.',
		selecioneAoMenosUmLeitor: 'Select at least one reader for the document',
		selecioneAsCargasTransportadas: 'Select the transported loads',
		selecioneInspecaoAbaixo: 'Select an inspection below',
		selecioneOAcesso: 'Select the access',
		selecioneOTipo: 'Select type',
		selecioneOUsuario: 'Select the user',
		selecioneOrdemMissaoAbaixo: 'Select the order the mission below.',
		selecioneOrdemMissaoPrevencaoAbaixo: 'Select the qualified prevention mission order below.',
		selecioneOrdemMissaoPrevencaoQualificada: 'Select a qualified prevention mission order',
		selecioneOrgaos: 'Select the Organs',
		selecioneOsPassageirosTrecho: 'Select the passengers that flew this leg',
		selecioneOsTrechosAgrupados: 'Select the Legs to be grouped below.',
		selecioneParaExibir: 'Select an item to open the settings.',
		selecioneParaExportar: 'Select format for data export',
		selecionePrioridade: 'Select a priority',
		selecioneSeDesejaNotificar: 'Select whether to notify',
		selecioneUmContrato: 'Select a Contract',
		selecioneUmContratoAtivo: 'Select an active contract',
		selecioneUmContratoOculto: 'Select an hidden contract',
		selecioneUmContratoOcultoParaHabilitar: 'Select an hidden contract to enable',
		selecioneUmEmpenho: 'Select an effort',
		selecioneUmManual: 'Select a manual',
		selecioneUmMotor: 'Select an Engine',
		selecioneUmaAero: 'Select an aircraft to begin with.',
		selecioneUmaAeronave: 'Select an aircraft',
		selecioneUmaCor: 'Pick a Color',
		selecioneUmaFatura: 'Select an invoice',
		selecioneUmaFuncao: 'Select a Function',
		selecioneUmaMoeda: 'Select a currency',
		selecioneUmaOrdemDeMissao: 'Select a Mission Order',
		selecioneUmaPrevencaoQualificada: 'Select qualified prevention',
		sem: 'Without',
		semDataInstalacao: 'PNs dated 00/00/0000 have not yet been installed',
		semMaisAlertas: 'No More Alerts',
		semMaisConversa: 'No more talking.',
		semPassageiros: 'No passengers',
		semSolicitacao: 'No request',
		semTermoAbertura: 'No opening term',
		semValor: 'Valueless',
		semVitimas: 'No Victims',
		semana: 'Wekeend',
		semanas: 'Weeks',
		senha: 'Password',
		senhaInvalida: 'Invalid password.',
		senhaSpider: 'Spider password',
		senhaUtilizadaAoLogar: 'Password used to login to the system',
		senhasNaoCoincidem: 'The password typed does not match',
		separado: 'separated',
		seraExibidoTodas: 'all aircraft will be displayed in quadrant monitoring',
		seraExibidoTodasElas: 'all aircraft will be displayed',
		seraNecessarioAssinarAlgumaInspecaoParaConfirmarNovasAlteracoesNosDadosDessaOrdemDeServico: 'You will need to sign an inspection to confirm new changes to the data for that work order',
		seraNecessarioAssinatura: 'A new pilot signature will be required',
		serialNumberMotor: 'Serial Number Engines',
		servicesWS: 'Services WS',
		servico: 'Service',
		servicos: 'Services',
		servicosAExecutar: 'Services to be executed',
		servicosExecutados: 'Services performed',
		sessao: 'Session',
		sessaoAtualizada: 'Updated session',
		sessaoExpirada: 'Session expired',
		setor: 'Sector',
		setorDestino: 'Target sector',
		setorOuOrgaoExterno: 'Sector / External agency',
		sexo: 'Genre',
		sgpe: 'SGP-e file number of individual digital folder',
		sigla: 'Initials',
		sim: 'Yes',
		simples: 'Simple',
		simulador: 'SIMULATOR',
		sistema: 'System',
		sistemaIntegrado: 'Integrated System',
		sistemasDoCliente: 'Customer Systems',
		situacao: 'Situation',
		situacaoDoPagamento: 'Payment Situation',
		situacaoTripulacao: 'Crew Situation',
		sn: 'SN',
		snCelula: 'SN CELL',
		snDeEntrada: 'Incoming SN',
		snDeSaida: 'Outgoing SN',
		snOvn: 'NVG Serial Number',
		soRecomendacoes: 'Recomendation',
		sobre: 'About',
		socorridos: 'Rescued',
		solicitaNumeroVoo: 'Request Flight number',
		solicitaUsoAeronave: 'Request for aircraft use',
		solicitacao: 'Request',
		solicitacaoCancelada: 'Request canceled.',
		solicitacaoCriadaDeUmaOrdemDeServico: 'Request created from a service order',
		solicitacaoInserida: 'Request entered in the system.',
		solicitacaoSalva: 'Request Saved',
		solicitacaoSalvaComSucesso: 'Request Saved Successfully',
		solicitacoes: 'Requests',
		solicitacoesDeEdicao: 'Editing Request',
		solicitacoesEdicao: 'Edit Requests',
		solicitacoesFeitaPorVoce: 'Requests made by you',
		solicitacoesItensAvulsas: 'Single Item Requests',
		solicitacoesParaVoce: 'Requests for you',
		solicitado: 'Requested',
		solicitadoEm: 'Requested On',
		solicitante: 'Requester',
		solicitanteCancelou: 'Applicant canceled',
		solicitanteDaMissao: 'Mission Applicant',
		solicitanteSelecionado: 'This user will only be saved as an applicant in system profiles.',
		solicitar: 'Request',
		solicitarItemAvulso: 'Request single item',
		solicitarItens: 'Request Itens',
		solicitarNumeroVoo: 'Request flight number',
		solicitarOS: 'You have to save the WO to order supplies.',
		solicitarSuprimento: 'Request Supplies',
		solo: 'Ground',
		solteiro: 'Single',
		somaDiurnoNoturno: 'The sum of the "Day" and "Night" fields must equal the "Pilot"s Flight Time',
		somaIfrVfr: 'The sum of the "VFR" and "IFR" fields must equal the "Pilot"s Flight Time',
		somentePeso: 'Weight only',
		souPiloto: 'I\'m a pilot',
		status: 'Status',
		statusContrato: 'Contract Status',
		statusDaExecucao: 'Execution status',
		statusDaRecomendacao: 'Recomendation status',
		statusExcluidoComSucesso: 'Status deleted successfully!',
		statusFoiSalvoComSucesso: 'Status has been saved successfully!',
		statusLeitura: 'Read Status',
		statusLicencas: 'Remaining days to expiration.',
		suaSecaoExpirou: 'Your section has expired.',
		suaSessaoExpirou: 'Your session has expired.',
		subEclassificacao: 'Subclassification and Classification',
		subcategoria: 'Subcategory',
		subclassificacao: 'Subclassification',
		subclassificacaoAtualizada: 'Subclassification Updated',
		subclassificacaoDesativada: 'Subclassification disabled',
		subclassificacaoExcluida: 'Subclassification excluded',
		subclassificacaoInstrucao: 'Instruction Subclassification?',
		subclassificacaoSalva: 'Subclassification Added',
		subtitulo: 'Subtitle',
		suporte: 'Support',
		suprimento: 'Supply',
		suprimentoAeronauticos: 'Aeronautical Supplies',
		suprimentos: 'Supplies',
		tabela: 'Table',
		tamanho: 'Scale',
		tamanhoTelaLogin: 'Width of the login screen in pixels',
		tanque: 'Tank',
		tarefaAdicionada: 'Task Added',
		tarefaCadastrada: 'Registered Task',
		tarefaRemovidaComSucesso: 'Task successfully removed',
		tarefas: 'Tasks',
		tas: 'Tas',
		telaCheia: 'Full Screen',
		telefone: 'Telephone',
		telefoneCelular: 'Cell phone',
		telefoneDeEmergencia: 'Emergency phone',
		telefoneResidencial: 'Home Phone',
		temUmTermino: 'There is a term',
		template: 'Template',
		tempo: 'Time',
		tempoBusca: 'Tempo Search',
		tempoDePreenchimento: 'Filling Time',
		tempoDeVoo: 'Flight time',
		tempoEstimado: 'Estimated time',
		tempoEstimadoViaAr: 'ETA via AIR',
		tempoIndisponibilidade: 'Downtime',
		tempoNotificao: 'Notification Time',
		tempoRestante: 'Remaining time',
		tempoSessao: 'Session Time',
		tempoSobrevoo: 'Overflight Time',
		tempoTotal: 'Total Time',
		tempoTotalPiloto: 'Total Pilot Time:',
		tempoVooMuitoGrande: 'Last Report Date',
		tentativas: 'Attempts',
		teorico: 'THEORETICAL',
		termino: 'Conclusion',
		terminoOrdem: 'End of the Order',
		termoAbertura: 'Opening Term',
		termoAtualizado: 'Updated Term',
		termoDeUso: 'Terms of use',
		termoDescentralizacaoCredito: 'Credit Decentralization Term',
		termosDeUso: 'terms of use',
		texto: 'Text',
		textoDiaDiscrepancia: 'has a greater number of cases occurring on',
		textoDigiteSeuLogin: 'Enter your login and we will find the best way to set a new password.',
		textoHorarioDiscrepancia: 'at a time close to',
		textoLogin: 'Text on Login Screen',
		textoModificarSenha: 'To change your current password, type the new password in the field below.',
		textoNotificacao: 'Notification Text',
		textoSenhaAlteradaSucesso: 'Your password has been changed successfully!',
		ticket: 'Ticket',
		ticketCancelado: 'Canceled Ticket',
		timeline: 'TIMELINE',
		tipo: 'Type',
		tipoAcionamento: 'Activation Type',
		tipoAeronave: 'Aircraft Type',
		tipoAplicacao: 'Application Type',
		tipoArmazenamentoExcluido: 'Storage typo successfully deleted!',
		tipoCiclo: 'Cycle Type',
		tipoCombustivel: 'Type of fuel',
		tipoContrato: 'Type of contract',
		tipoContratoExcluidoComSucesso: 'Contract type deleted successfully!',
		tipoContratoFoiSalvoComSucesso: 'Contract type has been saved successfully!',
		tipoControle: 'Control Type',
		tipoDeAmazenamentoSalvoComSucesso: 'Storage type successfully saved!',
		tipoDeArmazenamento: 'Storage Type',
		tipoDeCarga: 'Cargo type',
		tipoDeEntrada: 'Incoming Type',
		tipoDeLicenca: 'Type of License',
		tipoDePagamento: 'Payment type',
		tipoDePlano: 'Type of plan',
		tipoDeSolicitacao: 'Request type',
		tipoDeUsuario: 'User Type',
		tipoDeVoo: 'Type of flight',
		tipoDespacho: 'Type of Dispatch',
		tipoDoEvento: 'Event Type',
		tipoDoProduto: 'Product Type',
		tipoDocumento: 'Document Type',
		tipoDocumentoExcluidoComSucesso: 'Document type successfully deleted',
		tipoDocumentoSalvoComSucesso: 'Document type successfully saved',
		tipoEmbalagemCadastro: 'Type of packaging successfully created',
		tipoEntrada: 'Entry Type',
		tipoMapa: 'Type Map',
		tipoMissao: 'Mission Type',
		tipoMovimentacao: 'Movement Type',
		tipoOrdemDeMissao: 'Mission Order Type',
		tipoOrdemMissaoExcluidoComSucesso: 'Mission Order type deleted correctly.',
		tipoOrdemMissaoSalvoComSucesso: 'Mission Order Type successfully saved.',
		tipoProximaIntervencao: 'Type of next Inspection',
		tipoTarefa: 'Task Type',
		tipoUltimaIntervencao: 'Type of last inspection',
		tipoUnidadeArmazenamento: 'Storage Unit Type',
		tiposDeSolicitacao: 'Request types',
		titulo: 'To generate the report, fill the fields below',
		tituloPrimario: 'Title',
		tituloTarefa: 'Task Title',
		tituloTicket: 'Title ',
		tituloTicketForm: 'Title: ',
		todas: 'All',
		todasAlteracoesSalvas: 'All changes will be save',
		todasAsFuncoes: 'All Functions',
		todasDiscrepanciasConcluidas: 'All discrepancies completed',
		todasInspecoes: 'All inspections',
		todasInspecoesAssinadaPeloInspetor: 'All inspections signed by the inspector.',
		todasInspecoesAssinadaPeloMecanico: 'All inspections signed by the mechanic.',
		todasInspecoesDesabilitadas: 'All inpections disabled',
		todasNaturezas: 'All Natures',
		todasNturezas: 'All Natures',
		todasSeraoExibidas: ' all will be displayed',
		todos: 'All',
		todosGrupos: 'All Groups',
		todosModelos: 'All models',
		todosOsContratos: 'all contracts',
		todosOsDiariosForamAssinados: 'OK! All Log Diaries of this aircraft have been signed.',
		todosOsTipos: 'All Kinds',
		todosOsTrechos: 'All Strechs',
		todosOsVoos: 'All Flights',
		todosProcessosOrdemMissaoOuDespachoConcluidos: 'All the processes of the order of mission or dispatch have been completed.',
		tolerancia: 'Max. Limit',
		toleranciaDisponivel: 'Tolerance Available',
		tooltipDescricaoFatos: 'Description of the facts, necessarily informing what and how it happened. Some examples of occurrence are the death of a passenger in the flight, a woman in labor, transmission of a virus etc.',
		tooltipLocalOcorrencia: 'Place of occurrence, necessarily, by the code of locality or geographical coordinate if in the ground and, obligatorily by geographical coordinate, if in flight.',
		tooltipQualificacaoCivil: 'Best possible civil qualification of the persons involved (full name, identification document used for embarkation, nationality and date of birth, among others).',
		tooltipReabrirDespacho: 'Reopen Dispatch',
		tornarRecomendacaoDeConhecimentoPublico: 'Make recomendation public',
		totais: 'Totals',
		total: 'Total',
		totalCapacidadeMaxima: 'Total maximum capacity',
		totalCiclosAviao: 'Total Cycles',
		totalCiclosVoados: 'Total Winged Cycles',
		totalDeCiclosNF: 'Total NF Cycles',
		totalDeCiclosNG: 'Total NG Cycles',
		totalDeCiclosNP: 'Total NP Cycles',
		totalDecolagemPouso: 'Total Takeoff to Landing',
		totalDeGancho: 'Total Hooks',
		totalDeGuincho: 'Total Winches',
		totalDeOcorrencias: 'Total occurrences',
		totalDePartidas: 'Total Departures',
		totalDePousos: 'Total Landings',
		totalDia: 'Total on day',
		totalDoCurso: 'Training total',
		totalHorasPiloto: 'Total Hours (Pilot)',
		totalHorasUtilizacao: 'Total Usage Hours',
		totalHorasVoadas: 'Total Hours Flown',
		totalNaoRastreado: 'Total untracked',
		totalPago: 'Total Paid',
		totalRastreado: 'Total tracked',
		totalvolume: 'Total Volume',
		trabalho: 'Job',
		transferencia: 'Transfer',
		transferenciaBase: 'Transfer of Basis',
		transicao: 'Transicion',
		trecho: 'Leg',
		trechoAdicionado: 'Leg added.',
		trechoAgrupadoPor: 'Excerpt grouped by',
		trechoAposData: 'Stretchs can only have an activation date after the cutoff date of the last stretch',
		trechoAssinado: 'Leg Signed',
		trechoDesagrupado: 'Ungrouped Leg.',
		trechoExcluido: 'Excluded segment.',
		trechoJuntado: 'Grouped Leg.',
		trechosAgrupados: 'Grouped leg',
		trechosQueOPassEstara: 'Leg that the passenger will be',
		treinamento: 'Training',
		tres: 'Three',
		trigrama: 'Trigram',
		tripulacao: 'Crew Members',
		tripulacaoZero: 'You have to add a crew',
		trocaEquipamentoAeronave: 'Exchange aircraft equipment',
		trocaSucesso: 'Exchange successfully completed',
		trocar: 'Change',
		trocarVoo: 'Change flight',
		tudoCerto: 'All right, the applicant can now receive the item(s)!',
		txtNovoTipoHabilitacao: 'Click on new license',
		ubidadeDeOrgaoApoiadoSalvoComSucesso: 'Unit of supported organ successfully saved',
		ultima: 'Last',
		ultimaAtualizacaoDaManutencao: 'Last maintenance update',
		ultimaData: 'Last Date',
		ultimaInspecao: 'Last intervention',
		ultimaManutencaoRealizada: 'Last maintenance done',
		ultimo: 'Last',
		ultimoServico: 'Last Service',
		ultimoVoo: 'Last Flight',
		ultimos30Dias: 'Last 30 Days',
		ultimos60Dias: 'Last 60 Days',
		ultimos90Dias: 'Last 90 Days',
		um: 'One',
		umCampoObrigatorio: 'Please add at least one phone number',
		umDessesCampoEObrigatorio: 'One of these fields is required.',
		unidade: 'Unity',
		unidadeArmazenamento: 'Unit Storage',
		unidadeArmazenamentoSalvaComSucesso: 'Storage Unit successfully saved!',
		unidadeCompra: 'Purchase Unit',
		unidadeContabil: 'Accounting Unit',
		unidadeDeArmazenamentoDeDestino: 'Target Storage Unit',
		unidadeDeArmazenamentoDeOrigem: 'Source Storage Unit',
		unidadeDeConservacao: 'Conservation Unit',
		unidadeDeMedida: 'Unit of measure',
		unidadeDestino: 'Unit of Destiny',
		unidadeDoOrgao: 'Organ Unit',
		unidadeDoOrgaoApoiadoExcluidoComSucesso: 'Unit of supported organ successfully deleted',
		unidadeMedida: 'Measure Unit',
		unidadeOrcamentaria: 'Budget Unit',
		unidadeOrcamentariaExcluida: 'Budget Unit deleted',
		unidadeOrcamentariaSalvaComSucesso: 'Budget Unit saved successfully',
		unidadeOrgaoApoiado: 'Organ Supported Unit',
		unidadeOrigem: 'Unit of Origin',
		unidades: 'Units',
		upload: 'upload',
		url: 'URL',
		usaCAMP: 'Uses CAMP or Followair Maintenance',
		userSpider: 'User Spider',
		usoDe: 'Use of',
		usoDeAereonave: 'Use of aircraft',
		usoDeFlir: 'Use of FLIR',
		usoDeOvn: 'Use of OVN',
		usuario: 'User',
		usuarioDesativado: 'Disabled User',
		usuarioLicenca: 'License User',
		usuarioNaoTenha: 'user do not have',
		usuarioQuePodeVer: 'User that can see this contract',
		usuarioSemLicenca: 'User does not have License',
		usuarios: 'Users',
		usuariosAtivos: 'Enabled Users',
		usuariosAtivosInativos: 'Enabled / Desabled Users',
		usuariosDesativados: 'Disabled Users',
		usuariosSimultaneos: 'Concurrent Users',
		utcDate: 'UTC Date',
		utilizaManutencao: 'Uses Maintenance',
		utilizaSigiloOM: 'Uses Secrecy in Mission Order',
		utilizaTrigrama: 'Uses Trigram',
		utilizada: 'Used',
		validade: 'Shelf life',
		validadeEmMeses: 'Validity in Months',
		validando: 'Validating',
		validandoIntegridadeDoDiarioDeBordo: 'Validating logbook integrity',
		validandoSenha: 'Validating password',
		validandoTrecho: 'Validating stretch',
		validarDados: 'VALIDATE AIRCRAFT AND ENGINE DATA',
		validos: 'Valid',
		valor: 'Value',
		valorCursoTeorico: 'theoretical course value',
		valorDaHora: 'Hour Value',
		valorDoCiclo: 'Cycle Value',
		valorDoContrato: 'Contract value',
		valorDoLitro: 'Liter Value',
		valorDoPagamento: 'Payment value',
		valorEmpenhado: 'Efforted Value',
		valorFrete: 'Cost of Freight',
		valorHoraCursoPrático: 'value practical course',
		valorMaiorQueTempoPiloto: 'Value greater than pilot time',
		valorNaoPermitidoPorUltrapassarOValorContratado: 'Amount not allowed for exceeding the contracted amount',
		valorNaoPermitidoPorUltrapassarOValorEmpenhado: 'Amount not allowed for exceeding the effort amount',
		valorNumericoInvalido: 'Invalid numeric value.',
		valorProduto: 'Product Value',
		valorProdutoServico: 'Valor del Producto/Servicio',
		valorReal: 'Brazilian Real',
		valorRecuperado: 'Recovered Value',
		valorReferenteAData: 'Amount referring to the inspection date',
		valorReportado: 'Reported Value',
		valorTempoVoo: 'Flight time value',
		valorTotal: 'Total Value',
		valorTotalAbastecido: 'Total Value Supplied',
		valorTotalEmProdutosServicos: 'Total amount on products/services',
		valorTotalProduto: 'Total Product Value',
		valorTributos: 'Value Taxes',
		valorUnitario: 'Unitary Value',
		valorUnitarioTributos: 'Unit Value with Taxes',
		valordaMatricula: 'registration fee',
		valoresAtivos: 'Active values',
		valoresDoContrato: 'Contract values',
		valoresPorOrgao: 'Values by Agencies',
		varIndMeta: 'var % ind/tar',
		variacoes: 'Variations',
		vcTemQueDigitarSenha: 'You have to enter your password.',
		veiculo: 'Vehicle',
		veiculoExcluidoComSucesso: 'Vehicle successfully deleted',
		velocidade: 'Speed',
		velocidadeAtual: 'Current Speed',
		velocidadeMedia: 'Average speed',
		vencido: 'Expired',
		vencimento: 'Due date',
		vencimentos: 'Due dates',
		ver: 'See',
		verAcionamentoECorte: 'See start-up and cut-off',
		verDecolagemEPouso: 'See takeoff and landing',
		verEstoque: 'View stock',
		verTodos: 'See All',
		verificaBloqueioDiscrepancia: 'Check Lock Discrepancy',
		verificacao: 'MARK THE MANEUVER\'S EXECUTION IN THE PLACE CORRESPONDING',
		verificacaoDoVor: 'VOR verification',
		verificacaoSePodeExcluir: 'Checking whether you can exclude',
		verificados: 'Verified',
		verificando: 'Checking',
		verificandoSePodePreencher: 'Checking if you can write out',
		verificar: 'Check',
		verificarDisponibilidades: 'Check Availability',
		versao: 'Version',
		versaoApi: 'Api version',
		versaoArquivo: 'File version',
		vidaUtil: 'Lifespan',
		visaoGeral: 'Show All',
		visualizacoes: 'Views',
		visualizar: 'View',
		visualizarMalha: 'View Mesh',
		visualizarOrdemServico: 'View Service Order',
		visualizarRelatorio: 'View Report',
		vitima: 'Victim',
		vitimas: 'Victims',
		viuvo: 'Widower',
		voadas: 'Winged',
		voando: 'Flying',
		voce: 'You',
		voceAlterandoAeronave: 'You are changing the aircraft model',
		voceAlterandoModelos: 'You are changing all models',
		voceAlterandoSerial: 'You are changing the serial number model',
		voceEAAutoridadeSolicitante: 'Are you the requesting authority?',
		voceJaAddEssePerfil: 'You have already added this profile',
		voceJaAddItem: 'You have already added this item.',
		voceJaCadastrouItem: 'You have already registered this item.',
		voceNaoPodeAgrupar: 'You can not ungroup these Legs, they have already been filled.',
		voceNaoPodeExcluirEditando: 'You can not delete, someone is writing the diary.',
		voceNovaSenha: 'You have to enter the new password.',
		vocePodeAtualizar: 'You can now update the logbook',
		voceResponsavelPeloVoo: 'Are you responsible for the flight?',
		voceTem: 'You have',
		voceTemAddUmPerfil: 'You have to add at least one profile.',
		voceTemQueEscolherUnidade: 'You have to add at least one unit.',
		voceTemQueEsperarPois: 'You have to wait, then',
		voltar: 'Back',
		voltarMapa: 'back to map',
		volume: 'Volume',
		volumeAbastecido: 'Volume Supplyed',
		volumeAbastecidoUnidadeArmazenamento: 'Volume Supplyed (l)',
		volumeAtual: 'Current volume',
		volumeAtualMovimentacaoCombustivel: 'Current volume(l)',
		volumeEmLitros: 'Volume in Liters',
		volumeFinal: 'Final Volume',
		volumeFinalMovimentacaoCombustivel: 'Final Volume (l)',
		volumeMovimentacaoCombustivel: 'Volume (l)',
		volumeReal: 'Actual Volume',
		volumeTotalAbastecido: 'Total Volume Supplied',
		voo: 'Flight',
		vooAdicionadoSucesso: 'Flight added successfully',
		vooAssinadoPeloMecanico: 'Flight signed by the Mechanic',
		vooAssinadoPeloOperador: 'Flight signed by the Operator',
		vooAssinadoPeloPiloto: 'Flight signed by the Pilot',
		vooAssinadoPor: 'Signed flight by',
		vooDecimoCelula: 'Flight Tenth Airframe',
		vooDecimoMotor: 'Flight Tenth Powerplant',
		vooDeveConterPiloto: 'Instruction flight must contain a "Pilot in Instruction"',
		vooEspecial: 'Special Flight',
		vooFinal: 'Final Flight Hours',
		vooInicial: 'Initial flight hours',
		vooLegado: 'Legacy flight',
		vooNaoPreenchido: 'Unfilled flight',
		vooPreenchidoPor: 'Flight completed by',
		vooReferenteAData: 'Flight Related to Date',
		vooRegular: 'Regular Flight',
		vooSalvo: 'Successfully saved flight',
		vooTrocado: 'Flight Changed',
		voos: 'Flights',
		voosEspeciais: 'Special Flights',
		wsdlCampFeed: 'WSDL Feed',
		wsdlCampGeneral: 'WSDL General',
		wsdlCampStatus: 'WSDL Status',
		wsdlCampoWorkOrder: 'WSDL Work Order',
		zonaQuenteCriminalidade: 'Hot Zone of Danger',
		zoomAeronave: 'Zoom Aircraft',
		zoomMobile: 'Zoom (Mobile)',
		zoomPrincipal: 'Main Zoom',
		zoomRastreamento: 'Zoom Tracing',
		zqc: 'HZD',
	},
	login: {
		digiteLogin: 'Type your login',
		digiteSenha: 'Type your password',
		digiteSenhaAtual: 'Type your actual password',
		entrando: 'Entering',
		entrar: 'Login',
		textoErro: 'User or password are invalid',
	},
	menu: {
		administracao: 'General Administration',
		comercial: 'Commercial',
		despachoComercial: 'Commercial Dispatch',
		gestaoMalhaComercial: 'Commercial Network Management',
		menuAdministracao: 'Administration',
		menuAdministracaoEnsino: 'Administration of Education',
		menuCertificados: 'Certificates',
		menuExecucaoEnsinoTreinamento: 'Execution of Education/Trainings',
		menuGeral: 'General',
		menuGerenciais: 'Management',
		menuManutencao: 'Maintenance',
		menuManutencaoAeronave: 'Aircraft',
		menuMissao: 'Order',
		menuMonitoraAeronaves: 'Aircrafts',
		menuOrdem: 'Mission',
		menuProjeto: 'Projects',
		menuRastreador: 'Tracker',
		menuRastreamento: 'TRacking',
		menuRelatorios: 'Reports',
		menuTrello: 'Trello',
		menuTrocarEquipamento: 'Change Equipment',
		sairSistema: 'Do you want to the exit the system?',
		segurancaOperacional: 'Operational secuirty',
	},
	menuAGCadAula: {
		aberta: 'Opened',
		adicionarAula: 'ADD LESSON',
		aula: 'Lesson',
		aulaAtualizada: 'Lesson updated',
		aulaCancelada: 'Lesson succesfully cancelled',
		aulaEncerrada: 'Lesson succesfully closed',
		aulaInserida: 'Lesson added',
		aulaReaberta: 'Lesson successfully reopened',
		aulas: 'Lessions',
		aulasEFrequencias: 'Lessons and Frequencies',
		cancelada: 'Cancelled',
		duracaoNaoPodeMaiorQue: 'The Duration cannot be bigger than',
		encerrada: 'Closed',
		frequencias: 'Frequencies',
		msgAjudaAula: 'Click on the cards in the table to edit lessions or enter frequencies.',
		presente: 'Present',
	},
	menuAGCadTurma: {
		abertaParaInscricao: 'Inscription open',
		emAndamento: 'In progress',
		excluirTurma: 'Do you want to delete this class?',
		finalizada: 'Finished',
		novaTurma: 'New class',
		turmaAtualizada: 'Class updated',
		turmaInserida: 'Class added',
		turmaRemovida: 'Class succesfully removed',
		turmaTitulo: 'Class',
	},
	menuAGcadAluno: {
		acidente: 'In case of an accident notify',
		alergico: 'Are you allergic to any type(s) of medicine(s)? Describe it(s)',
		contato1: 'Home Phone',
		contato2: 'Cell phone',
		contato3: 'Contact 3',
		curso: 'Training',
		dadosPessoais: 'Personal Data',
		doSecao: 'Section',
		doc1: 'Document 1',
		doc2: 'Document 2',
		doc3: 'Document 3',
		docCategoria: 'Category',
		docCertidaoDeReservista: 'Certificate of Reservation',
		docCic: 'Register',
		docDataExpedicao: 'Date of issue',
		docIdentidade: 'Identity',
		docOrgaoExpeditor: 'General registry entity',
		docTituloEleitor: 'Election Title',
		docZona: 'Zone',
		documentacao: 'Documentation',
		doutorado: 'Doctorate',
		empresa: 'Company',
		ensinoFundamental: 'School',
		ensinoMedio: 'high school',
		entende: 'Understand',
		escolhaNivelInstrucao: 'Choose your instruction level',
		escreve: 'Write',
		eulieaceitootermo: 'I have read and agree to the terms above.',
		fala: 'Speak',
		fatorRH: 'RH Factor',
		filiacao: 'Filiation',
		grauParentesco: 'Degree of Kinship',
		habIFRaviaoP: 'Airplane IFR enablement - Practical',
		habIFRaviaoT: 'Airplane IFR enablement - Theoretical',
		habIFRhelicopteroP: 'Helicopter IFR enablement - Practical',
		habIFRhelicopteroT: 'Helicopter IFR enablement - Theoretical',
		habilitacao: 'For Drivers',
		idioma: 'Language',
		idiomasEstrangeiros: 'Foreign Languages',
		infoAdicionais: 'Additonal Information',
		inscricaoSalva: 'Registration saved successfully!',
		le: 'Read',
		menuAGalunoAdm: 'Administration',
		menuAGalunoCargo: 'Office',
		menuAGalunoDoc: 'Document',
		menuAGalunoEscolar: 'School',
		menuAGalunoFicha: 'Registration Form',
		menuAGalunoInsc: 'Registration',
		menuAGalunoInscs: 'Registrations',
		menuAGalunoNovaInsc: 'New Registration',
		menuAGalunoSexo: 'Gender',
		mestrado: 'Master\'s degree',
		nivelInstrucao: 'Instruction Level',
		nomeEmpresa: 'Company Name',
		nomeMae: 'Mother\'s Name',
		nomePai: 'Father\'s Name',
		numeroInscricao: 'Registration Number',
		outrasInfo: 'Other Information',
		paraPortadoresDeLicenca: 'For Licensees',
		pilotoCPaviao: 'Commercial Airplane Pilot - Practical',
		pilotoCPhelicoptero: 'Commercial Helicopter Pilot - Practical',
		pilotoCTaviao: 'Commercial Airplane Pilot - Theoretical',
		pilotoCThelicoptero: 'Commercial Helicopter Pilot - Theoretical',
		pilotoPPaviao: 'Private Airplane Pilot - Practical',
		pilotoPPhelicoptero: 'Private Helicopter Pilot - Practical',
		pilotoPTaviao: 'Private Airplane Pilot - Theoretical',
		pilotoPThelicoptero: 'Private Helicopter Pilot - Theoretical',
		requisitosParaOcurso: 'Requirements for this course.',
		sebrac: 'SEBRAC',
		simuladorVoo: 'Flight Simulator',
		superiorCompleto: 'Graduated',
		tipoSanguineo: 'Blood Type',
		voltarParaLista: 'Back to list',
	},
	menuAGcadCurso: {
		cadCursoAtualizado: 'Training updated',
		cadCursoCargaHoraria: 'Workload',
		cadCursoCliente: 'Click on \'New\'',
		cadCursoDisciplina: 'Subjects',
		cadCursoNovaDisciplina: 'Add New Subject',
		cadCursoPratico: 'Practical',
		cadCursoSecretaria: 'School of Flight',
		cadCursoSucesso: 'Training Added',
		cadCursoTeorico: 'Theoretical',
		cadCursoTitulo: 'Trainings',
		cadCursomenuMtexto2: 'Click on icon',
		cadCursomenuMtexto3: 'at list alongside',
		cadEditarCurso: 'Edit Training',
		cadNomeCurso: 'Training Name',
		cadNovoCurso: 'New Training',
		cadNovoTreinamento: 'New Training',
		cadValorCurso: 'Training value',
		disciplinaAvaliativa: 'Is discipline evaluative?',
		frequenciaParaAprov: 'Frequencie for approval',
		notaMinimalParaAprov: 'Minimal note for approval',
	},
	menuAGcadMatricula: {
		addMatricula: 'Registration added',
		attMatricula: 'Registration updated',
		cadCurso: 'Training',
		cadHabilitacao: 'License',
		cadMatriculaTitulo: 'Registration',
		cadNomeAluno: 'New Student',
		cadNovaMatricula: 'New Registration',
		cadNumero: 'Number',
		fechaMatricula: 'Registration ended',
	},
	menuAGcadPagamento: {
		addPagamento: 'Payment added',
		attPagamento: 'Payment updated',
		cadNovoPagamento: 'New Payment',
		cadPagamentoTitulo: 'Payment',
		cadValor: 'Value',
		codigoPagamento: 'Code',
		cursoHab: 'Training',
		fechaPagamento: 'Payment ended',
		nomeAluno: 'Name - Student',
	},
	menuAGinspecao: {
		menuAGaAeronave: 'of Aircrafts',
		menuAGatualizado: 'Inspection updated successfully.',
		menuAGcCiclo: 'Cicle',
		menuAGdadosInspecao: 'Inspection data',
		menuAGdescInspecao: 'Inspection description',
		menuAGeditarInspecao: 'Edit Inspection',
		menuAGgInspecao: 'Inspection Group',
		menuAGhHomem: 'Hour/Man',
		menuAGiAnos: 'Years',
		menuAGiDescricao: 'Description',
		menuAGiDias: 'Days',
		menuAGiHoras: 'Hours',
		menuAGiInspecao: 'Inspection',
		menuAGiMeses: 'Months',
		menuAGinserido: 'Inspection added successfully.',
		menuAGmInspecao: 'Model',
		menuAGmodelAeronave: 'Model',
		menuAGnInspecao: 'Nature',
		menuAGnovaInspecao: 'New Inspection',
		menuAGnumPeca: 'Piece Number',
		menuAGnumSerie: 'Serie Number',
		menuAGtInspecao: 'Type',
		menuAGtextoI1: 'Click on \'New Inspection\'',
		menuAGtextoI2: 'Click on icon',
		menuAGtextoI3: ' at list alongside.',
		menuAGvidaUtil: 'Inspection Life',
	},
	menuAGnovaEscala: {
		menuAGbusca: 'Search',
		menuAGcarregar: 'Load',
		menuAGtipoEscala: 'Type',
	},
	menuAGnovoCargo: {
		menuAGaddCargo: 'Post added',
		menuAGattCargo: 'Post updated',
		menuAGcadCargo: 'New Post',
		menuAGcadCargo2: 'Post register',
		menuAGdescCargo: 'Description',
		menuAGdescCargo2: 'Post Description',
		menuAGeditCargo: 'Edit Post',
		menuAGtexto1: 'Click on \'New\'',
		menuAGtexto2: 'Click on icon',
		menuAGtexto3: ' at list alongside.',
	},
	menuAGnovoGrupo: {
		cadGrupoTitulo: 'Group Inspection',
		menuAGaddGrupo: 'Group added',
		menuAGattGrupo: 'Group updated',
		menuAGcadGrupo: 'New Group',
		menuAGdescGrupo: 'Description',
		menuAGdescGrupo2: 'Group Description',
		menuAGeditGrupo: 'Edit Group',
		menuAGtextoG1: 'Click on \'New\'',
		menuAGtextoG2: 'Click on icon',
		menuAGtextoG3: ' at list alongside.',
		naturezaManutencao: 'Real Estate Management',
	},
	menuAGnovoOrgao: {
		cadOrgaoTitulo: 'Organ Register',
		menuAGaddOrgao: 'Organ added',
		menuAGattOrgao: 'Organ updated',
		menuAGcadOrgao: 'New Organ',
		menuAGdescOrgao: 'Description',
		menuAGdescOrgao2: 'Organ Description',
		menuAGeditOrgao: 'Edit Organ',
		menuAGtextoG1: 'Click on \'New\'',
		menuAGtextoG2: 'Click on icon',
		menuAGtextoG3: ' at list alongside.',
	},
	menuAGnovoPosto: {
		menuAGaddPosto: 'Post added',
		menuAGattPosto: 'Post updated',
		menuAGcadPosto: 'New Post',
		menuAGdescPosto: 'Description',
		menuAGeditPosto: 'Edit Post',
		menuAGtexto1: 'Click on \'New\'',
		menuAGtexto2: 'Click on icon',
		menuAGtexto3: ' at list alongside.',
	},
	menuAGnovoUsuario: {
		menuAGacesso: 'System access',
		menuAGanac: 'ANAC code',
		menuAGbairro: 'Neighborhood',
		menuAGbase: 'Base',
		menuAGbranco: 'In blank, keep the same password.',
		menuAGcadUser: 'New User',
		menuAGcadastroUsuario: 'User Registry',
		menuAGcargo: 'Position',
		menuAGcargo2: 'Position',
		menuAGcel1: 'Cellphone 1',
		menuAGcel2: 'Cellphone',
		menuAGcelular: 'Cellphone',
		menuAGcep: 'ZIP CODE',
		menuAGcidade: 'City',
		menuAGcomplemento: 'Complement',
		menuAGcpf: 'ID',
		menuAGdadosCadastrais: 'Registration data',
		menuAGdepto: 'Departament',
		menuAGdesejaExcluir: 'Do you wish to delete this user?',
		menuAGeditarUsuario: 'Edit user',
		menuAGemail: 'E-mail',
		menuAGestado: 'State',
		menuAGexcluir: 'Delete user',
		menuAGguarnicao: 'Is part of garrison?',
		menuAGguarnicao2: 'Garrison',
		menuAGid: 'Identity',
		menuAGlogin: 'Login',
		menuAGlogradouro: 'Public place',
		menuAGmarcarTodos: 'Mark all',
		menuAGmatricula: 'Registration',
		menuAGnao: 'No',
		menuAGnome: 'Name',
		menuAGnomeGuerra: 'War Name',
		menuAGnum: 'Number',
		menuAGnumOrdem: 'Order Number',
		menuAGorgao: 'Organ',
		menuAGposto: 'Office/Grade',
		menuAGprivilegio: 'System privileges',
		menuAGremover: 'Remove all privileges',
		menuAGsenha: 'Password',
		menuAGsim: 'Yes',
		menuAGsistema: 'Do you have access to the system?',
		menuAGtel1: 'Telephone 1',
		menuAGtel2: 'Telephone 2',
		menuAGtipo: 'Type',
		menuAGtipoCertificado: 'Certified type',
		menuAGusuarioAdicionado: 'User added successfully.',
		menuAGusuarioAtualizado: 'User updated successfully.',
		menuAGusuarioExcluido: 'User deleted successfully.',
		menuAGvalidadeCertificado: 'Certified validate',
		msgPrivilegio: 'Do you want to add more privileges?',
		pClasse: '1st Class',
		sClasse: '2nd Class',
		tClasse: '3rd Class',
	},
	menuAGpermutas: {
		menuAGaeronave: 'Aircraft involved',
		menuAGchefiaEspecial: 'Special Head of the Public Security Area',
		menuAGcidade: 'City',
		menuAGconclusao: 'Conclusion',
		menuAGdata: 'Date',
		menuAGemail: 'E-mail',
		menuAGenvolvidos: 'Involved',
		menuAGestado: 'State',
		menuAGfim: 'End',
		menuAGinicio: 'Start',
		menuAGlocal: 'Local',
		menuAGnome: 'Name',
		menuAGparecer: 'Seem',
		menuAGresposta: 'Answer',
		menuAGresposta2: 'Answer',
		menuAGsalvo: 'Saved successfully!',
		menuAGsecretariaAlagoas: 'Secretary of State for Public Security of Alagoas',
		menuAGsituacao: 'Situation',
		menuAGsolicitado: 'Requested',
		menuAGtel: 'Telephone',
		menuAGtipo: 'Type',
		menuAGtipo2: 'Type',
	},
	menuAGplanoManutencao: {
		boletins: 'Newsletters',
		comprimentoDeBoletins: 'COMPLIANCE WITH AIRWORTHINESS BULLETINS',
		comprimentodeBoletinsServico: 'COMPLIANCE WITH SERVICE BULLETINS',
		controleDeComponentesCeula: 'CONTROL OF AIRFRAME COMPONENTS',
		controleDeComponentesMotor: 'POWERPLANT COMPONENT CONTRACT',
		inspecoesAcessoriosMotor: 'PROGRAMMED POWERPLANT ACCESSORY INSPECTIONS',
		inspecoesProgramadas: 'SCHEDULED AIRFRAME INSPECTIONS',
		inspecoesProgramadasEquipamento: 'SCHEDULED EQUIPMENT INSPECTIONS',
		inspecoesProgramadasMotor: 'PROGRAMMED POWERPLANT INSPECTIONS',
		inspecoesRegulamentares: 'REGULATORY INSPECTIONS',
		manuAGNenhumaEncontrada: 'No Inspection Found.',
		menuAGInspecaoAtualizada: 'Updated inspections.',
		menuAGaddInspecao: 'Add Inspection to Plan',
		menuAGaddTodas: 'Add All',
		menuAGcelula: 'Airframe',
		menuAGdetalhes: 'Details',
		menuAGinspDetalhe: 'Inspection Details',
		menuAGinspecao: 'Inspection',
		menuAGinspecoes: 'Inspections',
		menuAGmodelo: 'Model',
		menuAGmotor: 'Motor',
		menuAGpeca: 'Part',
		menuAGperiodicidade: 'Periodicity',
		menuAGplano: 'Maintenance Plan',
		menuAGremoveTodas: 'Remove All',
		menuAGserie: 'Serie',
		revalidacoes: 'REVALIDATIONS AND CERTIFICATIONS',
	},
	menuAGprevencao: {
		menuAGNovaPrevencao: 'New Prevention',
		menuAGaeronave: 'Aircraft',
		menuAGaeronave2: 'Aircraft',
		menuAGcidade: 'City',
		menuAGcidade2: 'City',
		menuAGconcluir: 'Conclude prevention',
		menuAGconclusao: 'Description of the conclusion',
		menuAGdataOcorrencia: 'Occurrence date',
		menuAGdescricao: 'Description',
		menuAGemail: 'E-mail',
		menuAGenvolvidos: 'Staff involved',
		menuAGlocal: 'Local of occurrence',
		menuAGpPrevencao: 'Prevention',
		menuAGprevencaoConcluida: 'Prevention complete.',
		menuAGrelato: 'Preventive Reports',
		menuAGrelatoOcorrencia: 'The report of the occurrence presented here has as sole purpose the incentive to operational safety, therefore, its use is exclusively for the prevention of accidents. NO NEED TO BE SIGNED OR IDENTIFIED',
		menuAGrelator: 'Reporter',
		menuAGrelatorio: 'Preventive Reports',
		menuAGrelatorioAdicionado: 'Report added successfully.',
	},
	menuAGstatus: {
		cadStatusTitulo: 'Status Register',
		menuAGaddStatus: 'Status added',
		menuAGattStatus: 'Status updated',
		menuAGcadStatus: 'New Status',
		menuAGcadStatus2: 'Register status',
		menuAGdescStatus: 'Description',
		menuAGdescStatus2: 'Status description',
		menuAGeditStatus: 'Edit status',
		menuAGtexto1: 'Click on \'New\'',
		menuAGtexto2: 'Click on icon',
		menuAGtexto3: ' at list alongside.',
		obrigaStatus: 'Require you to enter a note when you select this status?',
	},
	menuAGtipoAfastamento: {
		cadAfastamentoTitulo: 'Absence Type Register',
		menuAGaddAfastamento: 'Absence added',
		menuAGattAfastamento: 'Absence updated',
		menuAGcadAfastamento: 'New absence',
		menuAGdescAfastamento: 'Description',
		menuAGdescAfastamento2: 'Absence description',
		menuAGeditAfastamento: 'Edit Absence',
		menuAGtextoG1: 'Click on \'New\'',
		menuAGtextoG2: 'Click on icon',
		menuAGtextoG3: ' at list alogside.',
	},
	menuAGtipoGuarnicao: {
		cadGuarnicaoTitulo: 'Garrison Type Register',
		menuAGaddGuarnicao: 'Garrison added',
		menuAGattGuarnicao: 'Garrison updated',
		menuAGcadGuarnicao: 'New Garrison',
		menuAGdescGuarnicao: 'Description',
		menuAGdescGuarnicao2: 'Garrison description',
		menuAGeditGuarnição: 'Edit Garrison',
		menuAGgOrdem: 'Order',
		menuAGgSigla: 'Initials',
		menuAGtextoG1: 'Click on \'New\'',
		menuAGtextoG2: 'Click on icon',
		menuAGtextoG3: ' at list alongside.',
	},
	menuAGtipoMissao: {
		cadMissaoTitulo: 'Mission Type Register',
		menuAGaddMissao: 'Mission added',
		menuAGattMissao: 'Mission updated',
		menuAGcadMissao: 'New Mission',
		menuAGdescMissao: 'Description',
		menuAGdescMissao2: 'Mission description',
		menuAGeditMissao: 'Edit Mission',
		menuAGtexto1: 'Click on \'New\'',
		menuAGtexto2: 'Click on icon',
		menuAGtexto3: ' at list alongside.',
	},
	menuAGtipoNatureza: {
		cadNaturezaTitulo: 'Nature Type Register',
		menuAGaddNatureza: 'Nature added',
		menuAGattNatureza: 'Nature updated',
		menuAGcadNatureza: 'New Nature',
		menuAGdescNatureza: 'Description',
		menuAGdescNatureza2: 'Nature description',
		menuAGeditNatureza: 'Edit Nature',
		menuAGnSigla: 'Initials',
		menuAGtexto1: 'Click on \'New\'',
		menuAGtexto2: 'Click on icon',
		menuAGtexto3: ' at list alongside.',
	},
	menuAGtipoOcorrencia: {
		cadOcorrenciaTitulo: 'Occurrence Type Register',
		menuAGaddOcorrencia: 'Occurrence added',
		menuAGattOcorrencia: 'Occurrence updated',
		menuAGcadOcorrencia: 'New Occurrence',
		menuAGdescOcorrencia: 'Description',
		menuAGdescOcorrencia2: 'Occurrence description',
		menuAGeditOcorrencia: 'Edit Occurrence',
		menuAGtexto1: 'Click on \'New\'',
		menuAGtexto2: 'Click on icon',
		menuAGtexto3: ' at list alongside',
	},
	menuAGtipoPrioridade: {
		cadPrioridadeTitulo: 'Priority Type Register',
		menuAGaddPrioridade: 'Priority added',
		menuAGattPrioridade: 'Priority updated',
		menuAGcadPrioridade: 'New Priority',
		menuAGdescPrioridade: 'Description',
		menuAGdescPrioridade2: 'Priority description',
		menuAGeditPrioridade: 'Edit Priority',
		menuAGtexto1: 'Click on \'New\'',
		menuAGtexto2: 'Click on icon',
		menuAGtexto3: ' at list alongside',
	},
	menuAdicionarPerfil: {
		paraAdicionar: 'To add a profile',
		selecionePerfil: 'select the profile and click on ADD',
	},
	menuAfastamento: {
		menuAadicionado: 'Request added successfully.',
		menuAaprovar: 'Approve',
		menuAatualizado: 'Request updated successfully.',
		menuAreprovar: 'Disapprove',
		tipo: 'Type',
	},
	menuArapiraca: {
		menuAescala: 'Loading Arapiraca scale',
		menuAnpg: 'Name - Office/Grad',
		menuAsalvo: 'Saved',
	},
	menuCadCiv: {
		CivAtualizado: 'CIV updated',
		CivRemovida: 'CIV successfully removed',
		CivSucesso: 'CIV added',
		cadCiv: 'CIV Registration',
		pilotoParticipante: 'Parcipating Pilot',
	},
	menuCadHabilitacao: {
		EditarHabi: 'Edit License',
		HabiAtualizado: 'License updated',
		HabiCliente: 'Click on \'New\'',
		HabiDescricao: 'Description',
		HabiSecretaria: 'School of Flight',
		HabiSucesso: 'License Added',
		HabiTexto1: 'Click on icon',
		HabiTexto2: 'at list alongside.',
		HabiTitulo: 'License',
		NovoHabi: 'New License',
	},
	menuCadPacote: {
		EditarPacote: 'Edit Package',
		NovoPacote: 'New Package',
		PacoteAtualizado: 'Package updated',
		PacoteCliente: 'Click on \'New\'',
		PacoteDescricao: 'Description',
		PacoteNumeroHoras: 'Workload',
		PacotePratico: 'Practical',
		PacoteSecretaria: 'School of Flight',
		PacoteSucesso: 'Package Added',
		PacoteTeorico: 'Theoretical',
		PacoteTexto1: 'Click on icon',
		PacoteTexto2: 'at list alongside.',
		PacoteTitulo: 'Package',
		ValorPacote: 'Package Value ',
	},
	menuConfiguracao: {
		emailAssunto: 'E-mail Subject',
		emailTexto: 'E-mail Text',
		pessoasNotificadas: 'Notified People',
		sms: 'SMS Text',
	},
	menuDiscrepancia: {
		discrepanciaCancelada: 'Discrepancy Canceled',
	},
	menuEdicaoDiario: {
		horimetroFinal: 'Final Flight Hours',
		horimetroInicial: 'Initial Flight Hours',
		nenhumEmpenhoAdicionado: 'No Effort added',
		nenhumMotorAdicionado: 'No engine added',
		tempoDeVoo: 'Time of flight',
	},
	menuErro: {
		menuEtitulo: 'Ops!',
		menuEtitulo2: 'Oh-ou!',
		menuTextoErro: 'Happened something wrong when you tried to do this action.',
		menuTextoErro2: 'Something tell me that you can\'t do that.',
	},
	menuEscala: {
		copilotos: 'Co-pilots',
		menuCarregaEscala: 'Loading scale',
		menuElegenda: 'Label',
		menuElegenda1: 'Legend',
		menuEnovaLegenda: 'New Legend',
		menuEtotalDia: 'Total of services per day',
		menuEvermelho: 'Correct the fields in red.',
		menuRemover: 'Remove',
		menuSalvaEscala: 'Saved',
		pilotoEcopiloto: 'Pilot and Copilot',
		pilotos: 'Pilots',
		radioOperador: 'Radio operator',
		secaoManutencao: 'Maintenance Section',
		sessaoManutencao: 'Maintenance Session',
		tripulanteArapiraca: 'Arapiraca Crewmember',
		tripulanteMaceio: 'Maceió Crewmember',
		tripulanteOperacional: 'Operational Crew',
	},
	menuMaceio: {
		menuMmaceio: 'Loading Maceió scale',
		menuMnpg: 'Name - Office/Grad',
		menuMsalvo: 'Saved',
		menuMtripulante: 'Crewmember already added.',
	},
	menuMalha: {
		editarSemana: 'Edit week',
		novaSemana: 'Add Week',
	},
	menuManutencao: {
		menuMapoio: 'Ground support',
		menuMapu: 'APU',
		menuMasaFixa: 'Motor Cycle',
		menuMatualizaManutencao: 'Update Maintenance',
		menuMatualizada: 'Maintenance updated successfully',
		menuMcelula: 'Airframe',
		menuMciclon1: 'N1 Cycles',
		menuMciclon2: 'N2 Cycles',
		menuMciclosNG: 'NG Cycles',
		menuMciclosT1: 'NF Cycles',
		menuMcodinome: 'Codename',
		menuMcontrolComp: 'Components Control',
		menuMcontrolCompDE: 'Components Control Of',
		menuMctm: 'C T M',
		menuMdataPrevista: 'Expected Date',
		menuMdescricao: 'Description',
		menuMdetalhes: 'Update',
		menuMdisponibilidade: 'Availability',
		menuMescolha: 'Chooice an option',
		menuMeventos: 'Events',
		menuMf: 'F - VACATION',
		menuMhHomemHora: 'Men/Hour',
		menuMhorasAtuais: 'Current Hours',
		menuMhorasTotais: 'Total Hours',
		menuMhrsAtuais: 'Current Hours',
		menuMinspProg: 'Scheduled Inspections',
		menuMinspProgDE: 'Scheduled Inspections Of',
		menuMinspProgEquip: 'Scheduled Equipment Inspections',
		menuMinspReg: 'Regulamentary Inspections',
		menuMmodelo: 'Model',
		menuMmotor: 'Powerplant',
		menuMnumSerie: 'Nº Serie',
		menuMpousosAtuais: 'Current Landings',
		menuMrevalidaC: 'Revalidations and certifications',
		menuMtecnico: 'Maintenance technician',
		menuMtotal: 'Total',
		menuMx: 'X - IS SCALED',
		menuNivel: 'Level',
		menuTipo: 'Type',
		menuUltimaDataAtualizacao: 'Last update',
	},
	menuMatricula: {
		assinaturaAluno: 'SIGNATURE OF STUDENT',
		atestadoBonsAntecedentes: 'Certificate of Good Background',
		cadastroAPU: 'APU Registration',
		candidadoEstrangeiro: 'Foreign Candidate?',
		capacidade: 'Capacity',
		cartaoIdentidade: 'ID card',
		carteriaIdentidadeEstrangeirosValidade: 'Identity card for foreigners with validity of stay',
		casoPossuaLicenca: 'If you have a license',
		certidaoCapacidadeFisisca: 'Physical Fitness Certificate',
		certidaoEscolaridade: 'Certificate of Education',
		copiaCertificadoEscolaridadeEstrangeiro: 'Copy of certificate of schooling (officially translated) from elementary school',
		copiaDocumentoViagem: 'Copy of Travel Document',
		copiaLicencaAtividade: 'Copy of the specific activity license or equivalent document (translated officially)',
		cpf: 'ID',
		declaracaoSubJudice: 'Declaration of the request that it is not SUB-JUDICE',
		desejaExcluirEsseTipo: 'Do you want to delete this Type?',
		documentacaoApresentada: 'Featured Documentation (Candidates)',
		documentacaoApresentadaEstrangeiros: 'Featured Documentation (Foreign Candidates)',
		exibirMatricula: 'Show License Plate',
		informacoesMatricula: 'Registration Information',
		matriculaSalva: 'Registration Successfully save!',
		naoSalva: 'Does not save',
		numeroMatricula: 'Registration Number',
		permissaoResidencia: 'Residence Permit',
		quantitativo: 'Quantitative',
		registroAbastecimento: 'Supply Record',
		requerimentoDoCantidado: 'Application for Candidate',
		responsavelMatricula: 'RESPONSIBLE FOR THE REGISTRATION',
		termoMatricula: 'Registration Form',
		termoTexto: 'I DECLARE THAT THIS STUDENT IS ENROLLED IN THIS TRAINING, FROM <strong>{{dataMatricula}}</strong>, REGISTRATION <STRONG>{{matricula}}</strong>, THE DOCUMENTATION REQUIREMENTS HAVE BEEN DELIVERED, ACCOMPANIED BY <STRONG>{{qtd4x4}}</STRONG> PORTRAITS 3X4.',
		tipos: 'Types',
		tituloEleitor: 'Title of Elector',
	},
	menuMoficina: {
		cadOficinaTitulo: 'Manufactory Register',
		menuMaddOficina: 'Manufactory added',
		menuMattOficina: 'Manufactory updated',
		menuMcadOficina: 'Register Manufactory',
		menuMeditOficina: 'Edit Manufactory',
		menuMresponsavel: 'Responsible',
		menuMtexto1: 'Click on \'New Manufactory\'',
		menuMtexto2: 'Click on icon',
		menuMtexto3: ' at list alongside.',
	},
	menuMonitoramento: {
		horaDia: 'Hour/Day',
		horaMes: 'Hour/Month',
		menuAeronaveNaoVoou: 'The aircraft did not fly today.',
		menuMonitora: 'Monitoring',
		menuMonitoraAeronaves: 'Aircrafts',
		menuTempoReal: 'Real Time',
		nenhumaManutencao: 'No scheduled maintenance.',
		totalCiclosVoadios: 'Total winged cycles',
		voosDia: 'Current flights',
	},
	menuMsolicitaManutencao: {
		menuMsolicitaAdd: 'Maintenance Request Updated.',
		menuMsolicitaAtt: 'Maintenance Request Added.',
		menuMsolicitaCancelar: 'Do you want to cancel this Maintenance Request?',
		menuMsolicitaDisponibilidade: 'Availability',
		menuMsolicitaEscolha: 'Choose the inspections below',
		menuMsolicitaEvento: 'Event',
		menuMsolicitaHhora: 'Mens Hour',
		menuMsolicitaHtotais: 'Total Hours',
		menuMsolicitaInspecoes: 'Inspections',
		menuMsolicitaManutencoes: 'Maintenance Requests',
		menuMsolicitaMesesDias: 'Months / Days',
		menuMsolicitaModalidade: 'Modality',
		menuMsolicitaNivel: 'Level',
		menuMsolicitaProxInspecao: 'Next Inspection',
		menuMsolicitaReferente: 'Requests for aircraft',
		menuMsolicitaSelecione: 'Select one or more inspections below and then click ADD',
		menuMsolicitaTipo: 'Type',
	},
	menuOpRadio: {
		carregando: 'Loading radio operator scaler',
	},
	menuOrdemMissao: {
		menuMissao: 'Mission',
		menuNova: 'New',
		menuNovaOrdem: 'New Order',
		menuOrdem: 'Order',
		menuOrdemEscolha: 'Choose',
		menuOrdemSolicitacao: 'Requested',
		menuOrdemmissao: 'Order Mission',
	},
	menuOrgaoApoiados: {
		orgao: 'Agency',
		orgaoApoiados: 'Agency Supported',
		orgaoCadastro: 'Agency Register',
		orgaosApoiados: 'Agencies Supported',
	},
	menuRGestatisticaVoo: {
		menuAeronave: 'Aircraft',
	},
	menuRGhorasVoadas: {
		menuRGaeronave: 'Aircraft',
		menuRGdataFim: 'End Date',
		menuRGdataInicio: 'Start Date',
		menuRGhorasReportadas: 'Reported hours',
		menuRGou: 'Or',
		menuRGrelatorio: 'This report has operational purposes and may generate a difference for more or less in total hours flown compared to the logbook.',
	},
	menuRGoperacoes: {
		menuAeronave: 'Aircraft',
		menuRGcomb: 'Fuel',
		menuRGde: 'From',
		menuRGpara: 'To',
		menuRGpartida: 'Take off',
		menuRGpax: 'Passengers',
		menuRGpousos: 'Landings',
		menuRGtdec: 'Tenth Flight Time',
		menuRGtipo: 'Type',
		menuRGtvoo: 'Time Flight',
		menuRelatorioOp: 'Report of Operations',
		menuTipo: 'Type',
	},
	menuRGordemmissao: {
		menuOMadicionados: 'Added',
		menuOMcargo: 'Position',
		menuOMcoordenador: 'Coordinator',
		menuOMdataInicio: 'The Order of Mission period must be between the Request period.',
		menuOMdataMaior: 'The start date cannot be bigger than end date',
		menuOMemail: 'E-mail',
		menuOMenviar: 'Send and save',
		menuOMescolha: 'Choose',
		menuOMfim: 'End',
		menuOMguarnicao: 'Aircrew',
		menuOMinicio: 'Start',
		menuOMlotacao: 'Sector',
		menuOMmissao: 'Mission Order',
		menuOMnaoDisponivel: 'not available at this moment.',
		menuOMnome: 'Name',
		menuOMoperacao: 'Operation',
		menuOMordemAdicionada: 'Order added successfully.',
		menuOMordemAtualizada: 'Order updated successfully.',
		menuOMordemEncerrada: 'Order closed successfully.',
		menuOMorgao: 'Organ',
		menuOMprioridade: 'Priority',
		menuOMsemdados: 'No data found.',
		menuOMtelefone: 'Telephone',
		menuOMtripulantes: 'Crewmember',
	},
	menuRGsolicitacoes: {
		menuRGnome: 'Name',
		menuRGoperacao: 'Operation',
		menuRGorgao: 'Organ',
		menuRGprioridade: 'Priority',
		menuRGrSolicitacoes: 'Requests Report',
		menuRGsemdados: 'No data found.',
		menuRGsolicitacao: 'Requests',
	},
	menuRastreamento: {
		menuRastrea: 'Tracking',
		menuRastreaAeronave: 'Aircraft',
		menuRmudar: 'Change',
		menuRtotal: 'Total',
	},
	menuSegurancaOperacional: {
		acaoesMitigadoras: 'Mitigating Actions',
		acionadoOrgaosExternos: 'Has the external organs that are part of <PRE-XXX> and / or <PLEM-SXXX> activated?',
		acoesForamSuficienteFinal: 'Were mitigating actions sufficient?',
		analiseEvento: 'Event Analysis',
		analiseFinal: 'Final Analises',
		analiseInicial: 'Initial Analysis',
		cliente: 'Customer',
		codigoControleInterno: 'Internal Control Code',
		codigoOACI: 'OACI Code',
		comoFoiAcionado: 'How it was triggered',
		condicoesEmQue: 'Conditions under which',
		dataDoOcorrido: 'Date of occurrence',
		deficienciasIdentificadas: 'Deficiencies found in the information',
		deficienciasPorFaltaRecursos: 'Deficiencies identified',
		descricaoEvento: 'Description of the event',
		disponibilizacaoAcomodacoes: 'Has accommodation been made available to family members and the public in general?',
		enviadaEm: 'Response sent to the Rapporteur on',
		evacuacaoTripulantes: 'Description of evacuation of crew / passengers',
		eventoOperacionalRelatadoAspectos: 'The reported operational safety event (ESO) involves one of the following aspects',
		executivo: 'Executive',
		exemplar: 'Copy ',
		existiaExemplar: 'Was there a copy ',
		fatoresContribuintes: 'Contributing Factors',
		foramAdequados: ' adequate and sufficient for the dismantling of the track?',
		horaDoOcorrido: 'Time of occurrence',
		houveDerramamentoCombustivel: 'Was fuel or oil spilled on the runway or location?',
		identifiqueAsCargas: 'Identify the hazardous cargo present at the event:',
		informacoesAtenderam: 'Did information meet the needs?',
		informante: 'Who reported',
		localDoOcorrido: 'Place of occurrence',
		motivosAcoesNaoSuficiente: 'Reasons for non-sufficiency',
		numeroDocumentoOrigem: 'Source Document No.',
		organizacoesEnvolvidas: 'Organizations Involved',
		orgaosEnvolvidos: 'External bodies involved',
		outrasInformacoes: 'Other information',
		paralisacaoOperacoes: 'Did the operations stop?',
		pistaInterditada: 'Was the runway blocked?',
		probabilidade: 'Probability that ESO will reoccur',
		quaisAcoesAdicionaisAdotadas: 'What additional actions should be taken?',
		questionarioGestorSegurancaOperacional: 'About the Operational Safety Manager',
		recursosDisponiveis: 'Were the resources available in ',
		remetente: 'Sender\'s name',
		respostaEnviadaAoRelator: 'Response sent to the rapporteur?',
		setoresResponsaveis: 'Sectors responsible for mitigation',
		severidade: 'Severity if the worst possible consequence of this event occurs',
		situacaoRelatada: 'Reported Situation',
		tempoPistaInterditada: 'Track time blocked',
		tempoRetomadaOperacoes: 'Time when operations returned to normal',
		tipoSituacao: 'Situation Type',
		tolerabilidade: 'Tolerability',
	},
	menuSistema: {
		suporteTecnico: 'Technical Support',
		usuarioSistema: 'User\'s System',
	},
	menuSolicitaApoio: {
		apoioAereo: 'Air support',
		codigoPnapa: 'Pnapa code',
		corrigirCampos: 'Please, correct the fields in red above.',
		dadosAtualizados: 'Data updated successfully!',
		destino: 'Destination',
		escolhaArquivo: 'Choose one file and click load.',
		escolherLocal: 'You have to choose at least  one local',
		menuCargo: 'Position',
		menuCoordenador: 'Coordinator',
		menuCoordenadorSolo: 'Ground Coordinator',
		menuDataEfim: 'The start and end date are obligatory',
		menuEscolha: 'Choose',
		menuFimOperacao: 'Operation end date',
		menuGrauPrioridade: 'Level of priority',
		menuInicioOperacao: 'Operation start date',
		menuLocalOperacao: 'Local of Operation',
		menuMissaoApoio: 'Support Mission',
		menuNomeOperacao: 'Operation Name',
		menuNovaSolicitacao: 'New Request',
		menuOrgaoSolicitante: 'Organ',
		menuSolicitaNova: 'New',
		menuSolicitacao: 'Request',
		menuTipoOcorrencia: 'Type of occurrence',
		naturezaEtipo: 'You have to add at least one Nature and Type.',
		novaOrdemMissao: 'New Mission Order',
		ordemMissaoInserida: 'New mission order inserted successfully',
		partida: 'Departure',
		removidos: 'All removed',
		solicitaApoio: 'Request',
		solicitacaoAdicionada: 'Request added successfully.',
		solicitacaoAtualizada: 'Request updated successfully.',
		statusAtualizado: 'Status updated successfully.',
	},
	menuTripOperacional: {
		carregando: 'Loading operacional scale',
		escalaD: 'D - NORMAL',
		escalaE: 'E - EXPEDIENT',
		escalaS: 'S - ON WATCH',
	},
	menuUsuarioANAC: {
		codigoAviacao: 'Aviation Agency Code',
	},
	menuVoo: {
		historico: 'History',
		menuVaeronave: 'Aircraft',
		menuVaerotatico: 'Op. Aerotático / Sup. Médico',
		menuVatualizaTrechos: 'Update Legs',
		menuVatualizaTrechos2: 'When updating the legs, the system will fetch all portions of the day and include them in the flight report, altered legs will be kept.',
		menuVbaseArapiraca: 'Arapiraca Base: 3530-3518',
		menuVbaseMaceio: 'Maceió Base: 4009-2040',
		menuVcaesp: 'CAESP',
		menuVchefeCaesp: 'Cheief of CAESP: 98884-7133',
		menuVchefeOp: 'Cheief of Operations: 98824-9657',
		menuVcodigo: 'Code',
		menuVcomb: 'Fuel',
		menuVcontato: 'Contact',
		menuVcorte: 'Landing',
		menuVde: 'From',
		menuVerroVoos: 'Error to load maps of month.',
		menuVescolha: 'Choose the aircraft to carry the days it flew.',
		menuVestadoAlagoas: 'State of Alagoas',
		menuVfechaRelatorio: 'Close Report',
		menuVhistorico: 'History of legs',
		menuVmapa: 'Map of legs',
		menuVmissao: 'Mission',
		menuVmodelo: 'Model',
		menuVnaturezaVoo: 'Nature of Flight',
		menuVnum: 'Nº',
		menuVnumRelatorio: 'Report Nº',
		menuVnumTrecho: 'legs Nº',
		menuVocorrencia: 'Occurrence',
		menuVpara: 'To',
		menuVpartida: 'Take off',
		menuVpax: 'Passengers',
		menuVpousos: 'Landings',
		menuVprefixo: 'Prefix',
		menuVreabreRelatorio: 'Reopen Report',
		menuVrelatorio: 'Flight report',
		menuVsemMapa: 'No map found.',
		menuVssp: 'SSP',
		menuVtdec: 'Flight Time Tenth',
		menuVtdesc: 'T Flight Tenth',
		menuVtipoMissao: 'Type of mission',
		menuVtotal: 'Total',
		menuVtrechos: 'Legs',
		menuVtvoo: 'Flight Time',
		menuVvoo: 'T Flight',
	},
	nomesMes: {
		abril: 'April',
		agosto: 'August',
		dezembro: 'December',
		fevereiro: 'February',
		janeiro: 'January',
		julho: 'July',
		junho: 'June',
		maio: 'May',
		marco: 'March',
		novembro: 'November',
		outubro: 'October',
		setembro: 'September',
	},
	pais: {
		alemao: 'German',
		brasil: 'Portuguese',
		espanhol: 'Spanish',
		eua: 'English',
		frances: 'French',
		ingles: 'English',
		italiano: 'Italian',
		paraguai: 'Spanish',
		portugues: 'Portuguese',
	},
	perfil: {
		PerfilInserido: 'Profile inserted',
		clickEmNovo: 'click in \'New\'',
		editarPerfil: 'Edit profile',
		nomePerfil: 'Name',
		novoPerfil: 'New Profile',
		paraAdicionar: 'to add',
		perfilAtualizado: 'Updated profile',
		perfilDoUsuario: 'User profile',
	},
	rampa: {
		adicionar: 'Add',
		aeronaves: 'Aircrafts',
		cabecalhoHtml: '<h3>RAMP</h3><h4 style="cursor: pointer">INSPECTION</h4>',
		canac: 'CANAC',
		cpf: 'ID',
		descricao: 'Description',
		digiteODesignativoDesejado: 'Enter the indicative',
		digiteOQueDesejaPesquisar: 'Please enter your search',
		documentoComDataValida: 'Document is within the expiry date',
		documentos: 'Documents',
		filtrarPor: 'Filter by',
		menuHtml: '<div class="sub-text">RAMP</div><div class="sub-text">INSPECTION</div>',
		naoExisteTripulantes: 'Use the options for filter the crew members.',
		nenhumDesignativoEncontrado: 'No indicatives to exhibition.',
		nenhumDocumentoEncontrado: 'No documents to exhibition.',
		nenhumaAeronaveEncontrada: 'No aircrafts to exhibition.',
		publicacoes: 'Publications',
		selecioneQuaisInformacoes: 'Choose which information will be displayed',
		selecioneUmaAeronave: 'Choose an aircraft',
		semDocumentosTripulante: 'No document attached for this crew.',
		status: 'Status',
		tripulacao: 'Crew',
		tripulante: 'Crew Member',
		tripulantes: 'Crew Members',
		ultimoDespachoDoVoo: 'Last Dispatch of Flight',
		validade: 'Validate',
		verificarDataDoDocumento: 'Please check the expiration dates on document',
		visualizarDiarioDeBordo: 'View Daily Logger',
	},
	registroDadosVoo: {
		aceleracaoVertical: 'Vertical Acceleration',
		altitudeAeronave: 'Aircraft Attitude',
		altitudeTerreno: 'Ground Altitude',
		altitudeVoo: 'Flight Altitude',
		alturaVoo: 'Flight Height',
		pressaoDoOleoTurbina: 'Turbine Oil Pressure',
		pressaoOleo: 'Oil Pressure',
		proa: 'BOW',
		torque: 'Torque',
		turbina: 'Turbine',
		variacaoTorque: 'Torque Variation',
		variaveisDeMonitoramento: 'MONITORING VARIABLES',
		velocidadeAeronave: 'Aircraft Speed',
		visualizacaoGraficos: 'Graphics View',
		visualizacaoInstrumentos: 'Instruments View',
	},
	submenu: {
		ControleAtividadeAerea: 'Air Activity Control',
		ExtratoCompleto: 'Complete Extract',
		aeronaves: 'Aircrafts',
		cadAcao: 'Register of Action Type',
		cadAfastamento: 'Register of Removal Type',
		cadCargo: 'Office Register',
		cadEscala: 'Schedule',
		cadEvento: 'Events Registration',
		cadPosto: 'Post Register',
		cadPrevencao: 'Prevention Register',
		cadUser: 'User Register',
		cadastroGrupoInspecao: 'Inspection Group Registration',
		comunicacaoESO: 'Risk mangment',
		curso: 'Training',
		dataDeConclusao: 'Date of the conclusion',
		disciplina: 'Major',
		escala: 'Scale',
		escalas: 'Scale',
		estatisticaVoo: 'Flight statistic',
		gestaoDeEnsino: 'Teaching management',
		gestaoDeFrequenciaAvaliacao: 'Management of Lessions, Frequencies and Evaluation',
		gestaoDoEnsino: 'Teaching Management',
		gestaoEscalas: 'Scale Management',
		horasRastreadas: 'Tracked Hours',
		horasVoadas: 'Flight Hours',
		inscricoesEMatricula: 'Registration and Enrollment',
		mostradores: 'Counters',
		permutas: 'Request Schedule Changes',
		prazoParaExecucao: 'Execution deadline',
		relatorioOperacoes: 'Operations Report',
		relatorioPrevencao: 'Preventive Reports',
		relatorioSolicitacoes: 'Requests Report',
		relatorioVoo: 'Flight report',
		segurancaOperacionalEso: 'Risk management (ESO)',
		segurancaOperacionalRac: 'Civil Aviation Report (RAC)',
		segurancaOperacionalRelPrev: 'Prevention Report (RelPrev)',
		segurancaOperacionalRire: 'Initial Emergency Response Report (RIRE)',
		subAdministracao: 'Administration',
		subAtaConclusao: 'Record of Conclusion',
		subCertificadoConclusao: 'Certificate of Conclusion of Training',
		subEnsino: 'Teaching',
		subEscolar: 'School',
		subFichaDeAvaliacao: 'Form of Evaluation of Performance in Flight',
		subOrdem: 'Mission',
		subPagamentos: 'Payments',
		subRelatorio: 'Reports',
		subRelatorioOrdem: 'Mission Report',
		subSolicitacoes: 'Request',
		subTurmas: 'Classes',
		telaCheia: 'Full Screen',
		teoricoEPratico: 'Theoretical and practical',
	},
	uploadfile: {
		arquivoRequired: 'Required to insert a file',
		download: 'Download',
		erroMSG: 'This type of file is not allowed.',
		extPermitidas: 'Allowed extensions',
		foto: 'Photo',
		tituloForm: 'Attach file',
	},
}
